import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  HostListener,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { ViewChild, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { element } from 'protractor';
import { MatTabBody } from '@angular/material/tabs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ToastrService } from 'ngx-toastr';
import { FolderReqVm } from 'src/app/viewModels/core/folder-req-vm';
import { DeleteDocumentReqVm } from 'src/app/viewModels/core/delete-document-req-vm';
import { DocumentsByFolderReqVm } from 'src/app/viewModels/core/upload-document-req-vm';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { DocumentService } from '../../services/coreService/document.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { AddFolderReqVm } from 'src/app/viewModels/core/add-folder-req-vm';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { TemplateReqVM } from 'src/app/viewModels/core/template-req-vm';
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';
import { HttpClient, HttpBackend } from '@angular/common/http';
declare var require: any;
const FileSaver = require('file-saver');
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Input } from '@angular/core';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ContactsService } from '../../services/coreService/contacts.service';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FormAuditType, GroupType, ModuleName, ProjectTempType } from '../../services/coreService/contact.enum';
const { detect } = require('detect-browser');
const browser = detect();
import { CdkDrag, CdkDropList, CdkDragEnter, CdkDragExit, CdkDragStart } from '@angular/cdk/drag-drop';
import { asapScheduler, asyncScheduler } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CCCName } from 'src/app/applicationModules/eSignature/services/form.enum';
import { Add3ctypeformComponent } from 'src/app/middleware/common/add3ctypeform/add3ctypeform.component';
export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
})
export class DocumentsComponent implements OnInit {
  @Output() showShareFile = new EventEmitter<boolean>();
  @Output() documentViewer = new EventEmitter<boolean>();
  @Output() openDocumentDetail = new EventEmitter<boolean>();
  @Output() messageToEmit = new EventEmitter<boolean>();
  @Input() folderID: number = 0;
  @Input() transactionID: number = 0;

  //Objects and Variables...
  addFolderForm: FormGroup;
  uploadForm: FormGroup;
  uploadFormPlaceHolder: FormGroup;
  addTemplateForm: FormGroup;
  updateFolderNameForm: FormGroup;
  appendTemplateForm: FormGroup;
  messageToParent: boolean = true;
  currentUser: any;
  selected = 'All';
  panelOpenState = false;
  organizationId: string;
  databaseId: string;
  responseHolder: any;
  addNewDoc: any = false;
  showSidePanel: any = false;
  folderList: any = [] = [];
  documentList: any;
  documentCount: number;
  formData: FormData;
  documentName: any;
  selectedFolderId: string = '';
  selectedFolderName: string = '';
  selectedFile: string = '';
  selectedFilePlaceHolder: string = '';
  documentDetail: boolean = true;
  list: boolean = false;
  grid: boolean = true;
  shareFile: boolean = true;
  documentStatus: any;
  templateName: string = '';
  templates: any;
  templateDocuments: any;
  uploadFormValue: boolean = false;
  alldocument: any;
  itemSelectedFile: boolean = false;
  ViewDocument: boolean = true;
  itemSelectedSortBy: boolean = true;
  selectedFileArray: any = [] = [];
  newArray1: boolean;
  indexExpanded: number;
  public innerWidth: any;
  clickEventsubscription: any;
  clickEventClosePanelFromDocDetails: any;
  clickEventsubscriptionPreviousNextContact: any;
  groupList: any = [];
  step = 0;
  TypeId: number;
  parentID: number = 0;
  FormFolderList: any;
  FormFolderListMiddleSection: any = ([] = []);
  menuHeader: any = [];
  activeNode: string = "";
  hierarchyList: any;
  breadCrumMenu: any = [];
  FormsubFolderFolderList: any;

  selectButtonShow: boolean = false;
  PlaceholderName: string = "";
  PlaceholderID: string = "";
  DocumentFolderID: string = "";
  FormID: string = "";
  fileManagerID: string = "";
  PlaceholderNameFound: boolean = false;

  MyDrivefoldersList: any;
  activeNodeFileManager: string = "";
  menuHeaderMyDrive: any = [];
  FileManagerFolderListLeft: any;
  selectButtonMyDriveShow: boolean = false;
  foldersMyDriveListShow: boolean = false;
  showLocalPanel: boolean = false;

  ipAddress: any;
  browsername: any;
  device: any;
  eventLogMessage: any;
  CCCList: any = [] = [];
  SelectedModuleName: any = [] = [];

  OfficeIDList: any = [];
  myOfficeID: any;
  ContactNames: string = "";
  SharedWithMeFormFolderList: any = [] = [];
  isShowForm: any = true;
  isSharedWithMe: any = false;
  SharedWithMeactive: boolean = false;
  SharedWithMeMyDriveFolderList: any = [] = [];
  isShowMyDrive: any = false;
  isSharedWithMeMyDrive: any = false;
  SharedWithMeMyDriveactive: boolean = false;
  @Output() htmlData = new EventEmitter<boolean>();
  LoggedInEmailId: string = "";
  participantMessageInfo: string = null;
  toogleInformation = true;
  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      formFolderName: node.formFolderName,
      formFolderID: node.formFolderID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  private _transformerFileManager = (node: FoodNodeFileManager, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      fileManagerItemID: node.fileManagerItemID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  treeControlFileManager = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattenerFileManager = new MatTreeFlattener(this._transformerFileManager, node => node.level, node => node.expandable, node => node.children);
  dataSourceFileManager = new MatTreeFlatDataSource(this.treeControlFileManager, this.treeFlattenerFileManager);


  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  dialogRef: MatDialogRef<any, any>;
  params: string = "";
  typeOfParticipant:number=0;

  constructor(private http: HttpClient, private httpbackend: HttpBackend, private contactsService: ContactsService,
    private formBuilder: FormBuilder, private dialog: MatDialog, private addFolderVM: AddFolderReqVm,
    private documentService: DocumentService, private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private statusConst: StatusConstant, private loaderService: LoaderService, private toastr: ToastrService,
    private getFolderVM: FolderReqVm, private deleteDocumentVM: DeleteDocumentReqVm, private getDocumentsByFolderVM: DocumentsByFolderReqVm,
    private templateReqVm: TemplateReqVM, private router: Router, private _dataSharingService: DataSharingService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.LoggedInEmailId = sessionStorage.getItem('email');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
    var skipInterceptor = new HttpClient(httpbackend);
    skipInterceptor.get<{ ip: string }>('https://jsonip.com').subscribe(data => {
      this.ipAddress = data.ip
    });
    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''),
      map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );
  }

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  ngOnDestroy() {
    this.clickEventsubscriptionPreviousNextContact.unsubscribe();
    this.clickEventClosePanelFromDocDetails.unsubscribe();
    this.clickEventsubscription.unsubscribe();
  }

  ngOnInit(): void {
    if (browser) {
      this.browsername = browser.name;
      this.device = browser.os;
    }
    this.uploadFormValue = true;
    this.innerWidth = window.innerWidth;
    this.documentName = '';
    this.addFolderForm = this.formBuilder.group({
      folderName: ['', [Validators.required]],
      templateID: [''],
    });
    this.uploadForm = this.formBuilder.group({
      documentName: [''],
      uploadDocument: ['', [Validators.required]],
    });
    this.uploadFormPlaceHolder = this.formBuilder.group({
      documentName: [''],
      uploadDocument: ['', [Validators.required]],
    });
    this.addTemplateForm = this.formBuilder.group({
      templateName: ['', [Validators.required]],
      isPublic: false,
    });
    this.updateFolderNameForm = this.formBuilder.group({
      folderName: ['', [Validators.required]],
    });
    this.appendTemplateForm = this.formBuilder.group({
      templateID: ['', [Validators.required]],
    });
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));

    var menuModulesLists = menuModulesList.filter(x => x.mainModuleName == CCCName.Contact);
    if (menuModulesLists.length > 0) {
      this.contactNames = menuModulesLists[0].orgModuleName;
    }

    var menuModulesLists = menuModulesList.filter(x => x.mainModuleName == CCCName.Core);
    if (menuModulesLists.length > 0) {
      this.coreNames = menuModulesLists[0].orgModuleName;
    }
    this.clickEventsubscriptionPreviousNextContact = this._dataSharingService.getNextPreviousDocumentFromContact().subscribe((result) => {
      if (result) {
        this.getAllFolders();
        this.selectedFileArray = [];
        this.ShowDownloadButton = false;
        this.ShowDeleteButton = false;
        this.ShowRequestButton = false;
        this.itemSelectedSortBy = true;
      }
    });

    this.clickEventClosePanelFromDocDetails = this._dataSharingService.getClosePanelFromDocDetailsContact().subscribe((result) => {
      if (result) {
        this.getAllFolders();
        this.selectedFileArray = [];
        this.ShowDownloadButton = false;
        this.ShowDeleteButton = false;
        this.ShowRequestButton = false;
      }
    });

    this.clickEventsubscription = this._dataSharingService.getRemoveRequestDocumentForContact().subscribe((result) => {
      if (result) {
        var placeholderID = Object.values(result)[7];
        let removeIndex = this.selectedFileArray.findIndex((itm) => itm.selectedDocument.placeholderID === placeholderID);
        if (removeIndex !== -1) this.selectedFileArray.splice(removeIndex, 1);

        if (this.folderList.length > 0) {
          this.folderList.map(e => {
            if (e.placeholders.length > 0) {
              e.placeholders.map(e1 => {
                if (e1.placeholderID == placeholderID) {
                  e1.isChecked = false
                }
                return e1;
              });
            }
          });
        }
      }
    });

    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    this.SelectedModuleName = menuModulesList.filter(x => x.mainModuleName == ModuleName.Contact);
    sessionStorage.setItem('edashboard', "false");
    this.getAllFolders();

    if (environment.production) {
      this.showLocalPanel = false;
    } else {
      this.showLocalPanel = true;
    }

    sessionStorage.setItem('HeaderModuleName', this.SelectedModuleName[0].orgModuleName);
    this._dataSharingService.sendSelectedModuleName(this.SelectedModuleName[0].orgModuleName);
    this._dataSharingService.sendShowFormsSiderbar(this.SelectedModuleName[0].orgModuleName);
  }


  // get all folders
  getAllFolders() {
    this.step = Number(sessionStorage.getItem('currentContactTabIndex'));
    this.getFolderVM.DatabaseID = Number(this.databaseId);
    this.getFolderVM.OrganizationID = Number(this.organizationId);
    this.getFolderVM.UserID = this.currentUser.UID;
    this.getFolderVM.transactionID = Number(sessionStorage.getItem('transactionID'));//Number(this.transactionID);
    this.getFolderVM.officeID = this.myOfficeID;
    this.getFolderVM.OfficeIDList = this.OfficeIDList;
    this.loaderService.show();
    this.documentService.GetAllContactDocumentPlaceholders(this.getFolderVM).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.folderList = response.data;
          if (this.folderList != null) {
            this.folderList.map(e => {
              if (e.placeholders.length > 0) {
                e.placeholders.map(e1 => {
                  e1.isChecked = false
                  return e1;
                });
              }
            });

            var GetFirstFolder:any=[]=[];
            GetFirstFolder =this.folderList[0];
            if(GetFirstFolder.placeholders.length==0){
             this.addNewDoc =  true;
             this.selectedFolderId = GetFirstFolder.documentFolderID;
            }
          }

          this.selectedFileArray = [];
          this.ShowDownloadButton = false;
          this.ShowDeleteButton = false;
          this.ShowRequestButton = false;

          if (this.indexExpanded == undefined) {
            this.indexExpanded = 0;
          }
          this.indexExpanded = this.indexExpanded;
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  fileTypeTolower(fileType: string) {
    return fileType.toLowerCase();
  }

  getplaceholdername(placeholdername) {
    if (placeholdername != null && placeholdername != undefined) {
      var x = placeholdername;
      var f = x.replace(/\..+$/, '');
      return f;
    }
  }

  shareFiles(message: boolean) {
    this.showShareFile.emit(message);
  }


  openDocumentViewer(message: boolean, document) {
    var ReqModel = {
      Fromdetail: false,
      placeholderID: document.placeholderID,
      documentFolderID: document.documentFolderID
    }
    this._dataSharingService.sendSelectedDocumentForContact(ReqModel);
    this.documentViewer.emit(message);
  }


  showDocumentDetail(message: boolean, document) {
    this._dataSharingService.sendSelectedDocumentForContactDetails(document);
    this.openDocumentDetail.emit(message);
  }

  showList() {
    this.list = !this.list;
    this.grid = false;
  }

  showGrid() {
    this.grid = !this.grid;
    this.list = false;
  }

  addFolder(templateRef: TemplateRef<any>) {
    this.getAllTemplates();
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }


  addTemplate(templateRef: TemplateRef<any>, folder) {
    this.dialog.open(templateRef);
    this.selectedFolderId = folder.documentFolderID;
    this.selectedFolderName = folder.documentFolderName;
  }

  renameTemplate(templateRef: TemplateRef<any>, folder) {
    this.dialog.open(templateRef);
    this.selectedFolderId = folder.documentFolderID;
    this.updateFolderNameForm.get('folderName').setValue(folder.documentFolderName);
  }

  appendTemplate(templateRef: TemplateRef<any>, folder) {
    this.appendTemplateForm.get('templateID').setValue(null);
    this.getAllTemplates();
    this.dialog.open(templateRef);
    this.selectedFolderId = folder.documentFolderID;
  }

  addReviewer(templateRef: TemplateRef<any>, isShare: boolean, isRole: boolean, document) {
    this.peoples = [];
    this.Roles = [];
    this.isRolePopup = isRole;
    this.isSharedAccessRolePopup = false;
    this.showContactRoleAddButton = false;
    this.showAddButton = false;
    this.documentId = document.documentFolderID;
    this.PlaceholderID = document.placeholderID;
    this.dialog.open(templateRef);
  }


  todo = [
    {
      role: 'Employee',
      color: 'primary'
    }
  ];

  done = [
    {
      role: 'Admisssion',
      color: 'warn'
    }
  ];

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }


  // togglePanels(index: number) {
  //   sessionStorage.setItem('currentContactTabIndex', `${index}`);
  //   this.indexExpanded = index;
  // }

  togglePanels(index: number,folder:any) {

    sessionStorage.setItem('currentContactTabIndex', `${index}`);

    this.indexExpanded = index;
    //== this.indexExpanded ? 0 : index;

    if(folder.placeholders.length==0){
      this.addNewDoc =  true;
      this.selectedFolderId = folder.documentFolderID;
    }
    
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 599) {
      var el = document.getElementById('document');
      el.classList.remove('list');
    }
  }


  showDocument(showNewDoc, selectedFolder) {
    this.addNewDoc = showNewDoc == true ? false : true;
    this.selectedFolderId = selectedFolder.documentFolderID;
  }



  deleteDocument(selectedDocument) {
    const message = `Are you sure you want to delete this document?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    var perdocId = selectedDocument.documentID;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.groupList = [];
          if (this.selectedFileArray.length > 0) {
            selectedDocument = this.selectedFileArray;
            for (let i = 0; i < this.selectedFileArray.length; i++) {
              const selecteddocumentID = this.selectedFileArray[i]
                .selectedDocument.documentID;
              this.groupList.push(selecteddocumentID);
            }
          }
          if (this.selectedFileArray.length == 0) {
            const selecteddocumentID = perdocId;
            this.groupList.push(selecteddocumentID);
          }

          this.deleteDocumentVM.DatabaseID = Number(this.databaseId);
          this.deleteDocumentVM.UserID = this.currentUser.UID;
          this.deleteDocumentVM.DocumentIDs = this.groupList;
          this.deleteDocumentVM.officeID = this.myOfficeID;
          this.deleteDocumentVM.OfficeIDList = this.OfficeIDList;
          this.loaderService.show();
          this.documentService.deleteDocument(this.deleteDocumentVM).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.selectedFileArray = [];
                this.ShowDownloadButton = false;
                this.ShowDeleteButton = false;
                this.ShowRequestButton = false;
                this.itemSelectedSortBy = true;
                this.getAllFolders();
                this.loaderService.hide();
                this.toastr.success('Document deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
                this.toastr.error('Document deletetion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Document deletetion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  deleteDocuments() {
    const message = `Are you sure you want to delete this document?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.groupList = [];
          for (let i = 0; i < this.selectedFileArray.length; i++) {
            const selecteddocumentID = this.selectedFileArray[i].selectedDocument.placeholderID;
            this.groupList.push(selecteddocumentID);
          }

          this.deleteDocumentVM.placeholderIDs = this.groupList;
          this.deleteDocumentVM.UserID = this.currentUser.UID;
          this.deleteDocumentVM.DatabaseID = Number(this.databaseId);
          this.deleteDocumentVM.organizationID = Number(this.organizationId);
          this.deleteDocumentVM.officeID = this.myOfficeID;
          this.deleteDocumentVM.OfficeIDList = this.OfficeIDList;
          this.loaderService.show();
          this.documentService.DeleteContactPlaceholder(this.deleteDocumentVM).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.selectedFileArray = [];
                this.ShowDownloadButton = false;
                this.ShowDeleteButton = false;
                this.ShowRequestButton = false;
                this.itemSelectedSortBy = true;
                this.getAllFolders();
                this.loaderService.hide();
                this.toastr.success('Document deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
              }
            } else {
              this.loaderService.hide();
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  // get documents by folder id
  getDocumentsByFolder(selectedFolderId) {
    this.getDocumentsByFolderVM.DatabaseID = Number(this.databaseId);
    this.getDocumentsByFolderVM.OrganizationID = Number(this.organizationId);
    this.getDocumentsByFolderVM.documentFolderID = selectedFolderId;
    this.getDocumentsByFolderVM.officeID = this.myOfficeID;
    this.getDocumentsByFolderVM.OfficeIDList = this.OfficeIDList;
    this.loaderService.show();
    this.documentService.getDocumentsByFolder(this.getDocumentsByFolderVM).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.folderList.documents = response.data;
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  valuechange(event, selectedFolder) {
    if (event != '') {
      this.uploadFormValue = false;
      this.uploadForm.controls['uploadDocument'].setValue(null);
      this.uploadForm.controls['documentName'].setValue(event);
      this.selectedFolderId = selectedFolder.documentFolderID;
    } else {
      this.uploadFormValue = true;
    }
  }

  // on upload file
  onSubmitPlaceHolder(document) {
    this.formData = new FormData();
    let files = this.uploadFormPlaceHolder.get('uploadDocument').value;
    if (files !== '' && files !== null) {
      let documentType = files[0].name.split('.').pop();
      this.formData.append('file', files[0]);
      this.formData.append('DocumentType', documentType);
    } else {
      this.toastr.warning('Please select document');
      return;
    }
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('OrganizationID', this.organizationId);
    this.documentName = this.documentName !== undefined ? this.documentName : 'placeHolder';
    this.formData.append('DocumentName', this.documentName);
    this.formData.append('DocumentString', '');
    this.formData.append('TemplateID', '1');
    this.formData.append('documentFolderID', this.selectedFolderId);
    this.formData.append('transactionID', sessionStorage.getItem('transactionID'));
    this.formData.append('DocumentId', document.documentID);
    this.loaderService.show();
    this.documentService.UploadContactDocument(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getAllFolders();
          this.documentName = '';
          this.selectedFile = '';
          this.uploadFormValue = true;
          this.uploadFormPlaceHolder.reset();
          this.addNewDoc = false;
          this.toastr.success('File uploaded successfully.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  // on upload file
  onSubmit() {
    this.formData = new FormData();
    let files = this.uploadForm.get('uploadDocument').value;
    if (files !== '' && files !== null) {
      var newfilename = files[0].name.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
      // var documentNameSplit = files[0].name.split('.');
      // if (documentNameSplit.length > 2) {
      //   this.toastr.warning('Please upload valid file name, please rename file.', '', {
      //     timeOut: 3000,
      //   });
      //   this.loaderService.hide();
      //   return;
      // }
      let documentType = newfilename.split('.').pop();
      this.formData.append('file', files[0]);
      this.formData.append('DocumentType', documentType);
    } else {
      this.toastr.warning('Please select document');
      return;
    }
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('OrganizationID', this.organizationId);
    this.documentName = this.documentName !== undefined ? this.documentName : 'placeHolder';
    this.formData.append('DocumentName', this.documentName);
    this.formData.append('DocumentString', '');
    this.formData.append('TemplateID', '1');
    this.formData.append('documentFolderID', this.selectedFolderId);
    this.formData.append('transactionID', sessionStorage.getItem('transactionID'));
    this.loaderService.show();
    this.documentService.AddContactDocument(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getAllFolders();
          this.documentName = '';
          this.selectedFile = '';
          this.uploadFormValue = true;
          this.uploadForm.reset();
          this.addNewDoc = false;
          this.toastr.success('File uploaded successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  // on upload file
  onSubmitPlaceHolderName() {
    this.formData = new FormData();
    let files = this.uploadForm.get('uploadDocument').value;
    if (files !== '' && files !== null) {
      let documentType = files[0].name.split('.').pop();
      this.formData.append('file', files[0]);
      this.formData.append('DocumentType', documentType);
    } else {
      this.formData.append('file', '');
      this.formData.append('DocumentType', '');
    }
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('OrganizationID', this.organizationId);
    let documentNames = this.uploadForm.get('documentName').value;
    if (documentNames != '' && documentNames != null) {
      this.documentName =
        this.documentName !== undefined ? this.documentName : 'placeHolder';
      this.formData.append('DocumentName', this.documentName);
    } else {
      this.documentName = files[0].name;
      this.documentName = this.documentName.split('.');
      this.documentName = this.documentName[0];
      this.formData.append('DocumentName', this.documentName);
    }

    this.formData.append('DocumentString', '');
    this.formData.append('TemplateID', '1');
    this.formData.append('documentFolderID', this.selectedFolderId);
    this.formData.append('transactionID', sessionStorage.getItem('transactionID'));
    this.loaderService.show();
    this.documentService.AddContactDocument(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getAllFolders();
          this.documentName = '';
          this.selectedFile = '';
          this.uploadFormValue = true;
          this.uploadForm.reset();
          this.addNewDoc = false;
          this.toastr.success('File uploaded successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  UploadFile(event: any, document) {
    if (event.target.files.length > 0) {
      this.UploadDocument(event, document);
    } else {
    }
  }

  // on upload file
  UploadDocument(event, document) {
    this.formData = new FormData();
    let files = event.target.files;
    if (files !== '' && files !== null && files != undefined) {
      if (files[0].name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
        return;
      }
      var newfilename = files[0].name.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
      //var documentNameSplit = files[0].name.split('.');
      // if (documentNameSplit.length > 2) {
      //   this.toastr.warning('Please upload valid file name, please rename file.', '', {
      //     timeOut: 3000,
      //   });
      //   this.loaderService.hide();
      //   return;
      // }
      let documentType = newfilename.split('.').pop();
      this.formData.append('file', files[0]);
      this.formData.append('DocumentType', documentType);
    } else {
      this.toastr.warning('Please select document');
      return;
    }
    this.formData.append('PlaceholderID', document.placeholderID);
    this.formData.append('DocumentId', '0');
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('DocumentName', "");
    this.formData.append('DocumentString', '');
    this.loaderService.show();
    this.documentService.UploadContactDocument(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getAllFolders();
          this.toastr.success('File uploaded successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }



  // add new folder
  addNewFolder(formValues) {
    this.dialog.closeAll();
    if (formValues != undefined) {
      this.addFolderVM.FolderName = formValues.folderName;
      this.addFolderVM.DatabaseID = Number(this.databaseId);
      this.addFolderVM.UserID = this.currentUser.UID;
      this.addFolderVM.OrganizationID = Number(this.organizationId);
      this.addFolderVM.OfficeID = Number(this.myOfficeID);
      this.addFolderVM.transactionID = Number(this.transactionID);
      this.addFolderVM.folderID = Number(this.folderID);
      if (formValues.templateID == '' || formValues.templateID == null
        || formValues.templateID == "" || formValues.templateID == undefined) {
        this.addFolderVM.TemplateID = 0;
      } else {
        this.addFolderVM.TemplateID = formValues.templateID;
      }
      this.loaderService.show();
      this.documentService.addFolder(this.addFolderVM).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.addFolderForm.reset();
            // this.ReorderfoldersforNewAddedfolder();   
            this.getAllFolders();
            this.toastr.success('Folder added successfully.', '', {
              timeOut: 3000,
            });
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }




  //add new Template
  addNewTemplate(formValues) {
    if (formValues !== undefined) {
      this.templateReqVm.templateName = formValues.templateName;
      this.templateReqVm.folderName = this.selectedFolderName;
      this.templateReqVm.DatabaseID = Number(this.databaseId);
      this.templateReqVm.UserID = this.currentUser.UID;
      this.templateReqVm.OrganizationID = Number(this.organizationId);
      this.templateReqVm.folderID = Number(this.folderID);
      this.templateReqVm.documentFolderID = Number(this.selectedFolderId);
      this.templateReqVm.OfficeID = this.myOfficeID;
      if (formValues.isPublic == null || formValues.isPublic == undefined) {
        formValues.isPublic = false;
      }
      this.templateReqVm.isPublic = formValues.isPublic;
      this.loaderService.show();
      this.documentService.addTemplate(this.templateReqVm).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.dialog.closeAll();
            this.addTemplateForm.reset();
            this.toastr.success('Template added successfully.', '', {
              timeOut: 3000,
            });
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  //rename Folder Name
  UpdateFolderName(formValues) {
    if (formValues !== undefined) {
      var ReqModel = {
        documentFolderID: Number(this.selectedFolderId),
        documentFolderName: formValues.folderName,
        userID: this.currentUser.UID,
        databaseID: Number(this.databaseId),
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        OfficeIDList: this.OfficeIDList
      }
      this.loaderService.show();
      this.documentService.RenameContactDocumentFolder(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.dialog.closeAll();
            this.getAllFolders();
            this.toastr.success('Folder name update successfully.', '', {
              timeOut: 3000,
            });
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  getAllTemplates() {
    this.templateReqVm.DatabaseID = Number(this.databaseId);
    this.templateReqVm.UserID = this.currentUser.UID;
    this.templateReqVm.OrganizationID = Number(this.organizationId);
    this.templateReqVm.folderID = Number(this.folderID);
    this.templateReqVm.OfficeID = this.myOfficeID;
    this.templateReqVm.OfficeIDList = this.OfficeIDList;
    this.loaderService.show();
    this.documentService.getAllTemplates(this.templateReqVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.templates = response.data;
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  OnSelectTempChange(templateID) {
    var Tempdata = this.templates.filter(x => x.templateID === templateID.value);
    if (Tempdata.length > 0) {
      var name = Tempdata[0].folderName;
      if (name != null) {
        this.addFolderForm.get('folderName').setValue(name);
      } else {
        this.addFolderForm.get('folderName').setValue("");
      }
    }
  }

  //get selected template documents
  getTemplateDocuments(event) {
    this.templateReqVm.DatabaseID = Number(this.databaseId);
    this.templateReqVm.UserID = this.currentUser.UID;
    this.templateReqVm.OrganizationID = Number(this.organizationId);
    this.templateReqVm.TemplateID = event.value;
    this.loaderService.show();
    this.documentService.getTemplateDocuments(this.templateReqVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.templateDocuments = response.data;
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  // append Template in existing folder
  appendTemplateInFolder(formValues) {
    if (formValues !== undefined) {
      this.templateReqVm.TemplateID = formValues.templateID;
      this.templateReqVm.DatabaseID = Number(this.databaseId);
      this.templateReqVm.UserID = this.currentUser.UID;
      this.templateReqVm.OrganizationID = Number(this.organizationId);
      this.templateReqVm.folderID = Number(this.folderID);
      this.templateReqVm.documentFolderID = Number(this.selectedFolderId);
      this.templateReqVm.transactionID = Number(this.transactionID);
      this.loaderService.show();
      this.documentService.appendTemplate(this.templateReqVm).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.dialog.closeAll();
            this.getAllFolders();
            this.toastr.success('Template appended successfully.', '', {
              timeOut: 3000,
            });
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }


  downloadAll(documents) {
    this.alldocument = documents.filter((s) => s.placeholderType == 1);
    for (let i = 0; i < this.alldocument.length; i++) {
      var ReqModel = {
        "transactionID": Number(sessionStorage.getItem("transactionID")),
        "placeholderID": this.alldocument[i].placeholderID,
        "userID": this.currentUser.UID,
        "organizationID": Number(this.organizationId),
        "databaseID": Number(this.databaseId)
      }
      this.documentService.DownloadDocument(ReqModel).subscribe((response) => {
        if (response != undefined && response.base64URL != null && response.base64URL != undefined) {
          const data = 'data:' + response.contentType + ';base64,' + response.base64URL;
          FileSaver.saveAs(data, response.name);
        } else {
          this.toastr.error('File download failed.', '', {
            timeOut: 3000,
          });
        }
      });
    }

  }


  DownloadSigleFile(filename: any) {
    var ReqModel = {
      "transactionID": Number(sessionStorage.getItem("transactionID")),
      "placeholderID": filename.placeholderID,
      "userID": this.currentUser.UID,
      "organizationID": Number(this.organizationId),
      "databaseID": Number(this.databaseId)
    }
    this.documentService.DownloadDocument(ReqModel).subscribe((response) => {
      if (response != undefined && response.base64URL != null && response.base64URL != undefined) {
        const data = 'data:' + response.contentType + ';base64,' + response.base64URL;
        FileSaver.saveAs(data, response.name);
      } else {
        this.toastr.error('File download failed.', '', {
          timeOut: 3000,
        });
      }
    });

  }

  //download selected File
  downloadSelecetedFile() {
    this.selectedFileArray;
    for (let i = 0; i < this.selectedFileArray.length; i++) {
      const placeholderType = this.selectedFileArray[i].selectedDocument.placeholderType;
      if (placeholderType == 1) {
        var ReqModel = {
          "transactionID": Number(sessionStorage.getItem("transactionID")),
          "placeholderID": this.selectedFileArray[i].selectedDocument.placeholderID,
          "userID": this.currentUser.UID,
          "organizationID": Number(this.organizationId),
          "databaseID": Number(this.databaseId)
        }
        this.documentService.DownloadDocument(ReqModel).subscribe((response) => {
          if (response != undefined && response.base64URL != null && response.base64URL != undefined) {
            const data = 'data:' + response.contentType + ';base64,' + response.base64URL;
            FileSaver.saveAs(data, response.name);
          } else {
            this.toastr.error('File download failed.', '', {
              timeOut: 3000,
            });
          }
        });
      }
    }
    this.selectedFileArray = [];
    this.getAllFolders();
    this.ShowDownloadButton = false;
    this.ShowDeleteButton = false;
    this.ShowRequestButton = false;
    this.itemSelectedSortBy = true;
  }

  // delete Folder
  removeFolder(folder) {
    const message = `Are you sure you want to delete this folder?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          if (folder !== undefined) {
            this.templateReqVm.OrganizationID = Number(this.organizationId);
            this.templateReqVm.DatabaseID = Number(this.databaseId);
            this.templateReqVm.UserID = this.currentUser.UID;
            this.templateReqVm.documentFolderID = Number(folder.documentFolderID);
            this.loaderService.show();
            this.documentService.removeFolder(this.templateReqVm).subscribe((response) => {
              if (response != undefined) {
                this.responseHolder = response;
                this.loaderService.hide();
                if (this.responseHolder.status == this.statusConst.statusSuccess) {
                  this.getAllFolders();
                  this.toastr.success('Folder removed successfully.', '', {
                    timeOut: 3000,
                  });
                } else {
                  this.loaderService.hide();
                }
              } else {
                this.loaderService.hide();
              }
            });
          }
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  close() {
    this.addTemplateForm.reset();
    this.addFolderForm.reset();
    this.peoples = [];
    this.selectedsharedAccessRole = [];
    this.Roles = [];

    // For Import Template //
    this.menuHeader = [];
    this.FormFolderListMiddleSection = [];
    this.FormFolderList = [];
    this.activeNode = "";
    this.SharedWithMeactive = false;
    this.selectButtonShow = false;

    // For My Drive // 
    this.menuHeaderMyDrive = [];
    this.MyDrivefoldersList = [];
    this.FileManagerFolderListLeft = [];
    this.activeNodeFileManager = "";
    this.selectButtonMyDriveShow = false;

    this.dialog.closeAll();
  }

  ShowRequestButton: boolean = false;
  ShowDownloadButton: boolean = false;
  ShowDeleteButton: boolean = false;

  //Checkbox Change detecting function
  getCheckboxValues(event, document) {
    this.itemSelectedSortBy = false;
    this.ShowDeleteButton = true;

    if (event.checked) {
      let ReqModel = {
        selectedDocument: document,
      };
      this.selectedFileArray.push(ReqModel);
      if (this.selectedFileArray.length > 0) {
        //Check for Download
        var checkDownload = [];
        checkDownload = this.selectedFileArray.filter((itm) => itm.selectedDocument.documentType != "");
        if (checkDownload.length > 0) {
          this.ShowDownloadButton = true;
        } else {
          this.ShowDownloadButton = false;
        }

        //Check for Request
        var checkRequest = [];
        checkRequest = this.selectedFileArray.filter((itm) => itm.selectedDocument.placeholderType != 2);
        if (checkRequest.length > 0) {
          this.ShowRequestButton = true;
        } else {
          this.ShowRequestButton = false;
        }
      }

      this.folderList.map(e => {
        if (e.placeholders.length > 0) {
          e.placeholders.map(e1 => {
            if (e1.placeholderID == document.placeholderID) {
              e1.isChecked = true
            }
            return e1;
          });
        }
      });
    } else {
      let removeIndex = this.selectedFileArray.findIndex((itm) => itm.selectedDocument === document);
      if (removeIndex !== -1) this.selectedFileArray.splice(removeIndex, 1);
      //Check for Download
      var checkDownload = [];
      checkDownload = this.selectedFileArray.filter((itm) => itm.selectedDocument.documentType != "");
      if (checkDownload.length > 0) {
        this.ShowDownloadButton = true;
      } else {
        this.ShowDownloadButton = false;
      }

      //Check for Request
      var checkRequest = [];
      checkRequest = this.selectedFileArray.filter((itm) => itm.selectedDocument.placeholderType != 2);
      if (checkRequest.length > 0) {
        this.ShowRequestButton = true;
      } else {
        this.ShowRequestButton = false;
      }

      this.folderList.map(e => {
        if (e.placeholders.length > 0) {
          e.placeholders.map(e1 => {
            if (e1.placeholderID == document.placeholderID) {
              e1.isChecked = false
            }
            return e1;
          });
        }
      });
    }
    if (this.selectedFileArray.length == 0) {
      this.ShowDownloadButton = false;
      this.ShowDeleteButton = false;
      this.ShowRequestButton = false;
      this.itemSelectedSortBy = true;
    }
  }



  isSharedAccessRolePopup: boolean = false;
  isRolePopup: boolean = false;
  contactsList: any = [];
  peoples: any = [];
  selectedsharedAccessRole: any = [];
  showAddButton = false;
  Module: string;
  showAddContact: boolean = false;
  sharedAccessRoleList: any = [];
  SharedRoleList: any = [];
  Roles: any = [];
  showContactRoleAddButton = false;
  documentId: number;
  isReviewerPopup: boolean = true;

  //=============For Reviewer ===========//

  selectSharedAccessRb(value) {
    this.contactemail = "";
    //== For Show Contact==//
    if (value == 1) {
      this.showContact = true;
      this.showRole = false;
      this.showSearchCore = false;
      this.isSharedAccessRolePopup = false;
      this.peoples = [];
      this.selectedsharedAccessRole = [];
      this.selectCoreList = [];
      this.showAddButton = false;
      this.selectedUser = false;
      this.isSharedAccessUserPopup = false;
      this.userSelectedList = [];
      this.sharedAccessUserList = [];
    }
    //== For Show Role==//
    if (value == 2) {
      this.showContact = false;
      this.showRole = true;
      this.showSearchCore = false;
      this.isSharedAccessRolePopup = true;
      this.peoples = [];
      this.selectedsharedAccessRole = [];
      this.selectCoreList = [];
      this.showAddButton = false;
      this.selectedUser = false;
      this.isSharedAccessUserPopup = false;
      this.userSelectedList = [];
      this.sharedAccessUserList = [];
    }
    //== For Show Core==// 
    if (value == 3) {
      this.showContact = false;
      this.showRole = false;
      this.showSearchCore = true;
      this.isSharedAccessRolePopup = false;
      this.selectCoreList = [];
      this.peoples = [];
      this.selectedsharedAccessRole = [];
      this.showAddButton = false;
      this.selectedUser = false;
      this.isSharedAccessUserPopup = false;
      this.userSelectedList = [];
      this.sharedAccessUserList = [];
    }

    // User
    if (value == 4) {
      this.showContact = false;
      this.showRole = false;
      this.isSharedAccessRolePopup = false;
      this.showSearchCore = false;
      this.isSharedAccessUserPopup = true;
      this.selectCoreList = [];
      this.peoples = [];
      this.selectedsharedAccessRole = [];
      this.userSelectedList = [];
      this.showAddButton = false;
      this.sharedAccessUserList = [];
    }
    // if (value == 2) {
    //   this.isSharedAccessRolePopup = true;
    //   this.peoples = [];
    //   this.selectedsharedAccessRole = [];
    //   this.showAddButton = false;
    // }
    // else {
    //   this.isSharedAccessRolePopup = false;
    //   this.peoples = [];
    //   this.selectedsharedAccessRole = [];
    //   this.showAddButton = false;
    // }
  }

  // selectSharedAccessRb(value) {
  //   if (value == 2) {
  //     this.isSharedAccessRolePopup = true;
  //     this.peoples = [];
  //     this.selectedsharedAccessRole = [];
  //     this.showAddButton = false;
  //   }
  //   else {
  //     this.isSharedAccessRolePopup = false;
  //     this.peoples = [];
  //     this.selectedsharedAccessRole = [];
  //     this.showAddButton = false;
  //   }
  // }


  userSelected(userSelected: any) {
    let user = this.peoples.find(m => m.userID == userSelected.uuid);
    if (user == undefined || user == '' || user == null) {
      this.peoples.push({
        name: userSelected.firstName + " " + userSelected.lastName,
        email: userSelected.email,
        img: "",
        userID: userSelected.uuid,
        roleID: 0,
        isShared: false,
        shortName: "",
        contactEntityID: Number(sessionStorage.getItem("transactionID"))
      });
      if (this.peoples.length > 0) {
        this.showAddButton = true;
      }
      else {
        this.showAddButton = false;
      }
    }
  }

  RoleSelectedForSharedAccess(roleSelected: any) {
    let role = this.selectedsharedAccessRole.find(m => m.roleID == roleSelected.roleID);
    if (roleSelected.roleID == 0) {
      let newRole = this.selectedsharedAccessRole.find(m => m.name.toLowerCase() == roleSelected.name.toLowerCase());
      if (newRole == undefined) {
        this.selectedsharedAccessRole.push({
          name: roleSelected.roleName,
          email: '',
          img: '',
          userID: "",
          roleID: roleSelected.roleID,
          isShared: false,
          shortName: '',
          contactEntityID: Number(sessionStorage.getItem("transactionID"))
        });
        if (this.selectedsharedAccessRole.length > 0) {
          this.showAddButton = true;
        }
        if (this.selectedsharedAccessRole.length == 0) {
          this.showAddButton = false;
        }
      }
      return;
    }

    if (role == undefined || role == '' || role == null) {
      this.selectedsharedAccessRole.push({
        name: roleSelected.roleName,
        email: '',
        img: '',
        userID: "",
        roleID: roleSelected.roleID,
        isShared: false,
        shortName: '',
        contactEntityID: Number(sessionStorage.getItem("transactionID"))
      });
    }

    if (this.selectedsharedAccessRole.length > 0) {
      this.showAddButton = true;
    }
    if (this.selectedsharedAccessRole.length == 0) {
      this.showAddButton = false;
    }
  }

  getSharedAccessRoles(searchValue: any) {
    var ReqModel = {
      searchKey: "",
      pageIndex: 0,
      pageSize: 0,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      searchValue: searchValue
    }
    this.contactsService.getSharedAccessRoles(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.sharedAccessRoleList = response.data;
          this.SharedRoleList;
          if (this.SharedRoleList.length > 0) {
            this.sharedAccessRoleList = this.sharedAccessRoleList.filter(({ roleID: id1 }) => !this.SharedRoleList.some(({ roleID: id2 }) => id2 === id1));
          }
        }
        else {
        }
      }
    });
  }

  timeout = null;

  searchUser(val) {
    this.contactsList = [];
    if (val != '') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getUserListCoreImplementation(val)
      }, 500);
    } else {
      this.contactsList = [];
    }
  }

  getUserListCoreImplementation(searchValue: any) {
    if (searchValue == "" || searchValue == null || searchValue == undefined) {
      this.contactsList = [];
      return;
    }
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      searchKey: searchValue.trim(),
      PageSize: 0,
      pageIndex: 0,
      UserID: this.currentUser.UID
    }
    this.contactsService.GetUserList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.contactsList = response.data.userModel;
          this.contactsList.map((res) => {
            if (res.email != null) {
              res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
            }
            if (res.firstName != null) {
              res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            }
            if (res.lastName != null) {
              res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            }
            return res;
          });
          this.contactsList = this.contactsList;
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  removeItem(item: any, isRolePopup: boolean) {
    if (this.isRolePopup) {
      const index = this.Roles.indexOf(item);
      if (index >= 0) {
        this.Roles.splice(index, 1);
      }
    }
    else {
      const index = this.peoples.indexOf(item);
      if (index >= 0) {
        this.peoples.splice(index, 1);
      }
    }
    if (this.peoples.length == 0) {
      this.showAddButton = false;
    }
    if (this.Roles.length > 0) {
      this.showContactRoleAddButton = true;
    }
    if (this.Roles.length == 0) {
      this.showContactRoleAddButton = false;
    }
  }

  removeItemRoleSharedAccess(item: any, isSharedAccessRolePopup: boolean) {
    if (this.isSharedAccessRolePopup) {
      const index = this.selectedsharedAccessRole.indexOf(item);
      if (index >= 0) {
        this.selectedsharedAccessRole.splice(index, 1);
      }
      if (this.selectedsharedAccessRole.length > 0) {
        this.showAddButton = true;
      }
      if (this.selectedsharedAccessRole.length == 0) {
        this.showAddButton = false;
      }
    }
  }

  SubmitReviewer() {
    if (this.isSharedAccessRolePopup == false) {
      if (this.peoples.length > 0) {
        this.dialog.closeAll();
        var ReviewerModelList = [];

        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var req = {
            contactEntityID: Number(sessionStorage.getItem('transactionID')),
            userID: this.peoples[i].userID,
            placeholderID: this.PlaceholderID,
            status: 1,   // By Default Send 1 // UnderReview = 1, Accepted = 2, Rejected = 3,
            roleID: 0,
          }
          ReviewerModelList.push(req)
        }

        var ReqModel = {
          addContactReviewerModelList: ReviewerModelList,
          DatabaseID: Number(this.databaseId),
          OrganizationID: Number(this.organizationId),
          UserID: this.currentUser.UID,
        }
        this.loaderService.show();
        this.contactsService.AddContactDocReviewer(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.toastr.success('User added successfully.', '', {
                timeOut: 3000,
              });
              this.getAllFolders();
              this.peoples = [];
              this.showAddButton = false;
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
      else {
        this.dialog.closeAll();
      }
    }

    if (this.isSharedAccessRolePopup == true) {
      if (this.selectedsharedAccessRole.length > 0) {
        this.dialog.closeAll();
        var ReviewerModelList = [];
        for (var i = 0, len = this.selectedsharedAccessRole.length; i < len; ++i) {
          var reqq = {
            contactEntityID: Number(sessionStorage.getItem('transactionID')),
            userID: "",
            placeholderID: this.PlaceholderID,
            status: 1,   // By Default Send 1 // UnderReview = 1, Accepted = 2, Rejected = 3,
            roleID: this.selectedsharedAccessRole[i].roleID,
          }
          ReviewerModelList.push(reqq)
        }

        var ReqModels = {
          addContactReviewerModelList: ReviewerModelList,
          DatabaseID: Number(this.databaseId),
          OrganizationID: Number(this.organizationId),
          UserID: this.currentUser.UID,
        }
        this.loaderService.show();
        this.contactsService.AddContactDocReviewer(ReqModels).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.toastr.success('Role added successfully.', '', {
                timeOut: 3000,
              });
              this.getAllFolders();
              this.selectedsharedAccessRole = [];
              this.showAddButton = false;
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
      else {
        this.dialog.closeAll();
      }

    }
  }


  // ==== Add Document and Import Form With 5 Cases ===== ////

  // Case -1 when add placeholder and type any name on add name
  AddCoreItemForPlaceholder() {
    this.formData = new FormData();
    let files = this.uploadForm.get('uploadDocument').value;
    if (files !== '' && files !== null) {
      var newfilename = files[0].name.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
      // var documentNameSplit = files[0].name.split('.');
      // if (documentNameSplit.length > 2) {
      //   this.toastr.warning('Please upload valid file name, please rename file.', '', {
      //     timeOut: 3000,
      //   });
      //   this.loaderService.hide();
      //   return;
      // }
      let documentType = newfilename.split('.').pop();
      this.formData.append('file', files[0]);
      this.formData.append('DocumentType', documentType);
    } else {
      this.formData.append('file', '');
      this.formData.append('DocumentType', '');
    }
    let documentNames = this.uploadForm.get('documentName').value;
    if (documentNames != '' && documentNames != null) {
      this.documentName = this.documentName !== undefined ? this.documentName : 'placeHolder';
      this.documentName = this.documentName;//.substring(0, 30);    //get first 30 chars
      this.formData.append('PlaceholderName', this.documentName);
    } else {
      this.documentName = files[0].name;
      this.documentName = this.documentName.split('.');
      this.documentName = this.documentName[0];
      this.documentName = this.documentName;//.substring(0, 30);    //get first 30 chars
      this.formData.append('PlaceholderName', this.documentName);
    }

    this.formData.append('PlaceholderType', '0');
    this.formData.append('PlaceholderID', '0');
    this.formData.append('FormID', '0');
    this.formData.append('DocumentFolderID', this.selectedFolderId);
    this.formData.append('TransactionID', sessionStorage.getItem('transactionID'));
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('OfficeID', this.myOfficeID);
    this.loaderService.show();
    this.documentService.AddContactItemForPlaceholder(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getAllFolders();
          this.documentName = '';
          this.selectedFile = '';
          this.uploadFormValue = true;
          this.uploadForm.reset();
          this.addNewDoc = false;
          this.toastr.success('Placeholder added successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  // Case 2 and Case 3
  SelectFormSubmit() {
    this.formData = new FormData();
    this.formData.append('TransactionID', sessionStorage.getItem('transactionID'));
    this.formData.append('DocumentFolderID', this.DocumentFolderID);
    this.formData.append('FormID', this.FormID);
    // this.formData.append('PlaceholderName', this.PlaceholderName.substring(0, 30)); //get first 30 chars
    this.formData.append('PlaceholderName', this.PlaceholderName);
    this.formData.append('PlaceholderType', '2');
    this.formData.append('PlaceholderID', this.PlaceholderID);
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('OrganizationID', this.organizationId);
    this.loaderService.show();
    this.close();
    this.documentService.AddContactItemForPlaceholder(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getAllFolders();
          this.documentName = '';
          this.selectedFile = '';
          this.uploadFormValue = true;
          this.uploadForm.reset();
          this.addNewDoc = false;
          this.toastr.success('Import Form successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  // Case -4 add new placeholder and Click on and drag and drop file or selected file
  onFileSelect(event, selectedFolder) {
    if (event.target.files.length > 0) {
      if (event.target.files[0].name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
        this.selectedFile = "";
        return;
      }
      this.uploadForm.get('uploadDocument').setValue(event.target.files);
      this.selectedFile = event.target.files[0].name;
      this.selectedFolderId = selectedFolder.documentFolderID;
      this.AddNewPlaceHolderAndUploadFile();
    } else {
      this.selectedFile = '';
    }
  }


  // Case -4 Calling Method
  AddNewPlaceHolderAndUploadFile() {
    this.formData = new FormData();
    let files = this.uploadForm.get('uploadDocument').value;
    if (files !== '' && files !== null) {
      var newfilename = files[0].name.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
      // var documentNameSplit = files[0].name.split('.');
      // if (documentNameSplit.length > 2) {
      //   this.toastr.warning('Please upload valid file name, please rename file.', '', {
      //     timeOut: 3000,
      //   });
      //   this.loaderService.hide();
      //   return;
      // }
      let documentType = newfilename.split('.').pop();
      this.formData.append('file', files[0]);
      this.formData.append('DocumentType', documentType);
    } else {
      this.formData.append('file', '');
      this.formData.append('DocumentType', '');
    }
    let documentNames = this.uploadForm.get('documentName').value;
    if (documentNames != '' && documentNames != null) {
      this.documentName = this.documentName !== undefined ? this.documentName : 'placeHolder';
      this.documentName = this.documentName;//.substring(0, 30); //get first 30 chars   
      this.formData.append('PlaceholderName', this.documentName);
      this.formData.append('DocumentName', this.documentName);
    } else {
      this.documentName = files[0].name;
      this.documentName = this.documentName.split('.');
      this.documentName = this.documentName[0];
      this.documentName = this.documentName;//.substring(0, 30); //get first 30 chars  
      this.formData.append('PlaceholderName', this.documentName);
      this.formData.append('DocumentName', this.documentName);
    }

    this.formData.append('PlaceholderType', '1');
    this.formData.append('PlaceholderID', '0');
    this.formData.append('FormID', '0');
    this.formData.append('DocumentFolderID', this.selectedFolderId);
    this.formData.append('TransactionID', sessionStorage.getItem('transactionID'));
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('OrganizationID', this.organizationId);
    this.loaderService.show();
    this.documentService.AddContactItemForPlaceholder(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getAllFolders();
          this.documentName = '';
          this.selectedFile = '';
          this.uploadFormValue = true;
          this.uploadForm.reset();
          this.addNewDoc = false;
          this.toastr.success('File uploaded successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  // Case -5 Choose existing placeholder and Click on and drag and drop file or selected file
  onFileSelectPlaceHolder(event, selectedFolder, document) {
    if (event.target.files.length > 0) {
      if (event.target.files[0].name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
        return;
      }
      this.uploadFormPlaceHolder.get('uploadDocument').setValue(event.target.files);
      this.selectedFilePlaceHolder = event.target.files[0].name;
      this.selectedFolderId = selectedFolder.documentFolderID;
      this.UploadFileWithExistingPlaceHolder(document);
    } else {
      this.selectedFile = '';
    }
  }


  // Case-5 Calling Method
  UploadFileWithExistingPlaceHolder(document) {
    this.formData = new FormData();
    let files = this.uploadFormPlaceHolder.get('uploadDocument').value;
    if (files !== '' && files !== null) {
      var newfilename = files[0].name.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
      // var documentNameSplit = files[0].name.split('.');
      // if (documentNameSplit.length > 2) {
      //   this.toastr.warning('Please upload valid file name, please rename file.', '', {
      //     timeOut: 3000,
      //   });
      //   this.loaderService.hide();
      //   return;
      // }
      let documentType = newfilename.split('.').pop();
      this.formData.append('file', files[0]);
      this.formData.append('DocumentType', documentType);
    } else {
      this.toastr.warning('Please select document');
      return;
    }
    this.formData.append('TransactionID', sessionStorage.getItem('transactionID'));
    this.formData.append('DocumentFolderID', this.selectedFolderId);
    this.formData.append('FormID', '0');
    this.formData.append('PlaceholderType', '1');
    // this.formData.append('DocumentName', document.placeholderName.substring(0, 30));  //get first 30 chars 
    // this.formData.append('PlaceholderName', document.placeholderName.substring(0, 30)); //get first 30 chars
    this.formData.append('DocumentName', document.placeholderName);
    this.formData.append('PlaceholderName', document.placeholderName);
    this.formData.append('PlaceholderID', document.placeholderID);
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('OrganizationID', this.organizationId);
    this.loaderService.show();
    this.documentService.AddContactItemForPlaceholder(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getAllFolders();
          this.documentName = '';
          this.selectedFile = '';
          this.uploadFormValue = true;
          this.addNewDoc = false;
          this.uploadFormPlaceHolder.reset();
          this.toastr.success('File uploaded successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  selectDrive(templateRef: TemplateRef<any>, folder) {
    this.dialog.open(templateRef, {
      panelClass: 'selectTemplate',
    });
    this.PlaceholderName = folder.placeholderName;
    this.PlaceholderID = folder.placeholderID;
    this.DocumentFolderID = folder.documentFolderID;
    if (this.PlaceholderName == null || this.PlaceholderName == undefined) {
      this.PlaceholderNameFound = true;
    } else {
      this.PlaceholderNameFound = false;
    }
    this.activeNodeFileManager = "";
    this.isShowMyDrive = true;
    this.isSharedWithMeMyDrive = false;
    this.SharedWithMeMyDriveactive = false;
    this.menuHeaderMyDrive = [];
    this.menuHeader = [];
    this.getFileManagerFoldersList(0);
    this.getFileManagerFolderList();
  }


  selectForm(templateRef: TemplateRef<any>, document, ReplaceFormstatus) {
    this.dialog.open(templateRef, {
      panelClass: 'selectTemplate',
    });
    if (ReplaceFormstatus == false) {
      this.PlaceholderName = document.placeholderName;
      this.PlaceholderID = document.placeholderID;
      this.DocumentFolderID = document.documentFolderID;
      if (this.PlaceholderName == null || this.PlaceholderName == undefined) {
        this.PlaceholderNameFound = true;
      } else {
        this.PlaceholderNameFound = false;
      }
    }

    if (ReplaceFormstatus == true) {
      this.PlaceholderName = document.placeholderName;
      this.PlaceholderID = document.placeholderID;
      this.DocumentFolderID = document.documentFolderID;
    }

    this.activeNode = "";
    this.dataSource.data = [];
    this.selectButtonShow = false;
    this.isShowForm = true;
    this.isSharedWithMe = false;
    this.SharedWithMeactive = false;
    this.menuHeaderMyDrive = [];
    this.menuHeader = [];
    this.getFormFolderListLeftPanel();
    this.getFormFolderListMiddlePanel();
  }

  // ===== My Drive ======//

  breadCrumbMyDriveMainClick() {
    this.MyDrivefoldersList = [];
    this.FileManagerFolderListLeft = [];
    this.menuHeaderMyDrive = [];
    this.activeNodeFileManager = "";
    this.getFileManagerFoldersList(0);
    this.getFileManagerFolderList();
    this.selectButtonMyDriveShow = false;
    this.foldersMyDriveListShow = false;
  }

  breadCrumbMyDrive(menu, index) {
    this.selectButtonMyDriveShow = false;
    this.menuHeaderMyDrive.splice(index + 1, this.menuHeaderMyDrive.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.MyDrivefoldersList = menu[index].items;
    }
    this.foldersMyDriveListShow = false;
    var data = this.menuHeaderMyDrive[index];
    this.getFileManagerFoldersList(data.id);
  }

  radioChangeMyDrive(form) {
    if (form.isFile == false) {
      this.showChildFolders(form);
      return;
    }
    if (form.name.split('.')[0].length > 120) {
      this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
        timeOut: 3000,
      });
      this.selectButtonMyDriveShow = false;
      return;
    }
    this.selectButtonMyDriveShow = true;
    if (this.PlaceholderNameFound == true) {
      this.PlaceholderName = form.name;//.substring(0, 30);//form.name; //get first 30 chars
      this.PlaceholderID = "0";
    }
    this.MyDrivefoldersList.forEach(e => {
      e.isChecked = false
    });

    this.MyDrivefoldersList.forEach(e => {
      if (e.fileManagerItemID == form.fileManagerItemID) {
        e.isChecked = true
      }
    });
    this.fileManagerID = form.fileManagerItemID;
  }

  getFileManagerFoldersList(folderId) {
    let reqModel = {
      fileManagerItemID: folderId,
      name: "",
      pageIndex: 0,
      pageSize: 0,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    }
    this.contactsService.FileManagerItemsWithHierarchy(reqModel).subscribe(response => {
      if (response.status == this.statusConst.statusSuccess) {
        this.MyDrivefoldersList = response.data.children;
        this.hierarchyList = response.data.hierarchy;
        if (this.hierarchyList == null || this.hierarchyList == null) {
          this.menuHeaderMyDrive = [];
        } else {
          this.menuHeaderMyDrive = [];
          this.hierarchyList.forEach(e => {
            this.menuHeaderMyDrive.push({ label: e.name, id: e.fileManagerItemID, icon: 'navigate_next' });
          });
        }
        this.MyDrivefoldersList.forEach(e => {
          e.isChecked = false;
        });
        if (this.MyDrivefoldersList == null || this.MyDrivefoldersList.length == 0) {
          this.MyDrivefoldersList = [];
          this.foldersMyDriveListShow = true;
        } else {
          this.foldersMyDriveListShow = false;
        }
      }
    });
  }


  getFileManagerFolderList() {
    let reqModel = {
      folderID: 0,
      folderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.contactsService.getFoldersListForFML(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FileManagerFolderListLeft = this.responseHolder.data.data;
          if (this.FileManagerFolderListLeft != null && this.FileManagerFolderListLeft != undefined) {
            this.dataSourceFileManager.data = this.FileManagerFolderListLeft;
          }
        }
        else {
        }
      }
      else {
      }
    });

  }


  showChildFolders(folder) {
    this.isShowMyDrive = true;
    this.isSharedWithMeMyDrive = false;
    this.selectButtonMyDriveShow = false;
    this.SharedWithMeMyDriveactive = false;
    this.activeNodeFileManager = folder.fileManagerItemID;
    this.getFileManagerFoldersList(folder.fileManagerItemID);
  }


  // ===== Shared with me My Drive ======//

  breadCrumbMainSHaredWithMeMyDriveClick() {
    this.selectButtonMyDriveShow = false;
    this.menuHeaderMyDrive = [];
    this.getSharedWithMeMyDrive();
  }

  breadCrumbSharedWithMeMyDrive(menu, index) {
    this.selectButtonMyDriveShow = false;
    this.menuHeaderMyDrive.splice(index + 1, this.menuHeaderMyDrive.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.MyDrivefoldersList = menu[index].items;
    }
    this.foldersMyDriveListShow = false;
    var data = this.menuHeaderMyDrive[index];
    this.showChildFoldersSharedWithMeMyDrive({ type: 1, id: data.id, isFile: data.isFile, name: data.label });
  }

  GetAllMyDrive() {
    this.activeNodeFileManager = "";
    this.dataSourceFileManager.data = [];
    this.selectButtonMyDriveShow = false;
    this.isShowMyDrive = true;
    this.isShowForm = false;
    this.isSharedWithMe = false;
    this.isSharedWithMeMyDrive = false;
    this.SharedWithMeactive = false;
    this.SharedWithMeMyDriveactive = false;
    this.menuHeader = [];
    this.menuHeaderMyDrive = [];
    this.getFileManagerFoldersList(0);
    this.getFileManagerFolderList();
  }

  getSharedWithMeMyDrive() {
    var ReqModel = {
      fileManagerItemID: 0,
      name: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      permissionType: 0
    }
    this.contactsService.GetSharedWithMeFileManager(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.SharedWithMeMyDriveFolderList = this.responseHolder.data;
          this.SharedWithMeMyDriveFolderList.forEach(e => {
            e.isChecked = false
          });
          if (this.SharedWithMeMyDriveFolderList != null) {
            this.SharedWithMeMyDriveFolderList.map((res) => {
              if (res.sharedbyFirstName != null) {
                res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
              }
              if (res.sharedbyLastName != null) {
                res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
              }
              return res;
            });
          }
          this.selectButtonMyDriveShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = true;
          this.SharedWithMeactive = false;
          this.SharedWithMeMyDriveactive = true;
          this.activeNode = "";
          this.activeNodeFileManager = "";
          this.menuHeader = [];
          this.menuHeaderMyDrive = [];
          this.foldersMyDriveListShow = false;
          this.parentID = 0;
        }
        else {
          this.selectButtonMyDriveShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = true;
          this.SharedWithMeactive = false;
          this.SharedWithMeMyDriveactive = true;
          this.activeNode = "";
          this.activeNodeFileManager = "";
          this.menuHeader = [];
          this.menuHeaderMyDrive = [];
          this.SharedWithMeMyDriveFolderList = [];
          this.foldersMyDriveListShow = false;
          this.parentID = 0;
        }
      }
      else {
      }
    });
  }

  showChildFoldersSharedWithMeMyDrive(folder) {
    this.isShowMyDrive = false;
    this.isSharedWithMeMyDrive = false;
    this.selectButtonMyDriveShow = false;
    this.isSharedWithMeMyDrive = true;
    this.SharedWithMeMyDriveactive = true;
    var folderId;
    if (folder.isFile == true) {
      this.menuHeaderMyDrive = [];
    }
    if (folder.fileManagerItemID == undefined) {
      folderId = folder.id;
    }
    if (folder.fileManagerItemID != undefined) {
      folderId = folder.fileManagerItemID;
    }

    this.menuHeaderMyDrive.push({
      label: folder.name,
      id: folderId,
      icon: 'navigate_next',
      isFile: folder.isFile
    });
    this.menuHeaderMyDrive = this.menuHeaderMyDrive.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);
    this.ChildFoldersSharedWithMeMyDrive(folder);
  }

  ChildFoldersSharedWithMeMyDrive(folder) {
    var folderId;
    if (folder.fileManagerItemID == undefined) {
      folderId = folder.id;
    }
    if (folder.fileManagerItemID != undefined) {
      folderId = folder.fileManagerItemID;
    }
    let reqModel = {
      fileManagerItemID: folderId,
      name: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      permissionType: 0
    }
    this.contactsService.GetSharedWithMeFileManagerWithHierarchy(reqModel).subscribe(response => {
      if (response.status == this.statusConst.statusSuccess) {
        this.SharedWithMeMyDriveFolderList = response.data;//.children; 
        this.parentID = folderId;
        if (this.SharedWithMeMyDriveFolderList != null) {
          this.SharedWithMeMyDriveFolderList.map((res) => {
            if (res.sharedbyFirstName != null) {
              res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
            }
            if (res.sharedbyLastName != null) {
              res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
            }
            return res;
          });
        }
        if (this.SharedWithMeMyDriveFolderList == null || this.SharedWithMeMyDriveFolderList.length == 0) {
          this.SharedWithMeMyDriveFolderList = [];
        }
      } else {

      }
    });
  }


  radioChangeMyDriveSharedWithMe(form) {
    var folderId;
    if (form.isFile == false) {
      if (form.fileManagerItemID == undefined) {
        folderId = form.id;
      }
      if (form.fileManagerItemID != undefined) {
        folderId = form.fileManagerItemID;
      }
      this.menuHeaderMyDrive.push({
        label: form.name,
        id: folderId,
        icon: 'navigate_next',
        isFile: form.isFile
      });
      this.menuHeaderMyDrive = this.menuHeaderMyDrive.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);
      this.ChildFoldersSharedWithMeMyDrive(form);
      return;
    }

    this.selectButtonMyDriveShow = true;
    if (this.PlaceholderNameFound == true) {
      this.PlaceholderName = form.name;//.substring(0, 30);//form.name; //get first 30 chars
      this.PlaceholderID = "0";
    }
    this.SharedWithMeMyDriveFolderList.forEach(e => {
      e.isChecked = false
    });

    if (form.isFile == true) {
      if (form.fileManagerItemID == undefined) {
        this.fileManagerID = form.id;
        this.SharedWithMeMyDriveFolderList.forEach(e => {
          if (e.id == form.id) {
            e.isChecked = true
          }
        });
      }
      if (form.fileManagerItemID != undefined) {
        this.fileManagerID = form.fileManagerItemID;
        this.SharedWithMeMyDriveFolderList.forEach(e => {
          if (e.fileManagerItemID == form.fileManagerItemID) {
            e.isChecked = true
          }
        });
      }
    }

  }

  //=====================//

  // ====  Import Form  ==== ///

  breadCrumbMainClick() {
    this.FormFolderListMiddleSection = [];
    this.getFormFolderListLeftPanel();
    this.getFormFolderListMiddlePanel();
    this.menuHeader = [];
    this.TypeId = 0;
    this.parentID = 0;
    this.selectButtonShow = false;
    this.activeNode = "";
  }

  breadCrumb(menu, index) {
    this.menuHeader.splice(index + 1, this.menuHeader.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.FormFolderList = menu[index].items;
    }
    var data = this.menuHeader[index];
    this.getformnavigate(data);
    this.selectButtonShow = false;
    this.parentID = data.id;
  }

  radioChange(form, FormOrShared) {
    if (FormOrShared == "SharedWithMe") {
      this.activeNode = "";
      this.SharedWithMeFormFolderList.forEach(e => {
        e.isChecked = false
      });
    }
    if (FormOrShared == "MyForm") {
      this.FormFolderListMiddleSection.forEach(e => {
        e.isChecked = false
      });
    }

    if (form.type == 1) {
      this.selectButtonShow = false;
      this.getform(form, FormOrShared);
    }

    if (form.type == 2) {
      if (this.PlaceholderNameFound == true) {
        this.PlaceholderName = form.name;
        if (this.PlaceholderID == undefined)
          this.PlaceholderID = "0";
      }
      this.FormID = form.id;
      this.selectButtonShow = true;
      if (FormOrShared == "MyForm") {
        this.FormFolderListMiddleSection.forEach(e => {
          if (e.id == form.id) {
            e.isChecked = true
          }
        });
      }
      if (FormOrShared == "SharedWithMe") {
        this.SharedWithMeFormFolderList.forEach(e => {
          if (e.id == form.id) {
            e.isChecked = true
          }
        });
      }
    }


  }

  // = Middle Panel FormFolderList Import Form =//

  getFormFolderListLeftPanel() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.loaderService.show();
    this.contactsService.getFormFolderList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FormFolderList = this.responseHolder.data;
          if (this.FormFolderList.length > 0) {
            this.dataSource.data = this.FormFolderList;
          }
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });

  }


  getFormFolderListMiddlePanel() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.contactsService.getFormFolderWithFormTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FormFolderListMiddleSection = this.responseHolder.data;
          this.FormFolderListMiddleSection.forEach(e => {
            e.isChecked = false
          });
        } else {
        }
      } else {
      }
    });

  }

  getform(form, FormOrSharedWithMe) {
    if (FormOrSharedWithMe == "MyForm") {
      this.activeNode = form.id;
    }
    if (FormOrSharedWithMe == "SharedWithMe") {
      this.activeNode = "";
    }
    this.TypeId = form.type;
    var type = form.type;

    //{ 1- Folder, 2- Form}
    if (type == 1) {
      var ReqModel = {
        formFolderID: form.id,
        formFolderName: '',
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        OfficeID: this.myOfficeID,
        databaseID: Number(this.databaseId),
      };
      this.contactsService.getFormFolderWithFormTemplates(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.FormFolderListMiddleSection = this.responseHolder.data;
            this.parentID = form.id;

            this.menuHeader.push({
              label: form.name,
              id: form.id,
              icon: 'navigate_next',
            });

            this.menuHeader = this.menuHeader.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);

          } else {
          }
        } else {
        }
      });
    } else {
    }
  }


  getformnavigate(form) {
    this.selectButtonShow = false;
    this.activeNode = form.id;
    var ReqModel = {
      formFolderID: form.id,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.contactsService.getFormFolderWithFormTemplates(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.FormFolderListMiddleSection = this.responseHolder.data;
        } else {
        }
      } else {
      }
    });
  }


  getIsFavorite(isFavorite) {
    isFavorite = isFavorite.isFavorite;
    return isFavorite;
  }


  // = Left Panel FormFolderList Import Form =//

  getFormFolderWithTemplatesLeftPanel(form) {
    this.selectButtonShow = false;
    this.activeNode = form.formFolderID;
    var ReqModel = {
      formFolderID: form.formFolderID,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.contactsService.getFormFolderWithFormTemplates(ReqModel).subscribe(res => {
      if (res != undefined) {
        this.responseHolder = res;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.FormsubFolderFolderList = this.responseHolder.data;
          this.contactsService.GetParentFormFolderHierarchy(ReqModel).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConst.statusSuccess) {
                this.hierarchyList = response.data.hierarchy;
                if (this.hierarchyList == null || this.hierarchyList == undefined) {
                  this.breadCrumMenu = [];
                  this.menuHeader = this.breadCrumMenu;
                  this.FormFolderListMiddleSection = this.FormsubFolderFolderList;
                  this.parentID = form.parentID;
                } else {
                  this.breadCrumMenu = [];
                  this.hierarchyList.forEach(e => {
                    this.breadCrumMenu.push({ label: e.formFolderName, id: e.formFolderID, icon: 'navigate_next' });
                  });
                  this.menuHeader = this.breadCrumMenu;
                  this.FormFolderListMiddleSection = this.FormsubFolderFolderList;
                  this.parentID = form.parentID;
                  this.isShowForm = true;
                  this.isSharedWithMe = false;
                  this.SharedWithMeactive = false;
                }
              }
            }
          });
        }
        else {
        }
      }
      else {
      }
    });

  }


  // Add CoreDocument from MyDrive Case 2 and Case 3
  AddCoreDocumentfromMyDrive() {
    // return;
    this.formData = new FormData();
    this.formData.append('TransactionID', sessionStorage.getItem('transactionID'));
    this.formData.append('DocumentFolderID', this.DocumentFolderID);
    this.formData.append('FileManagerID', this.fileManagerID);
    this.formData.append('FormID', '0');
    this.formData.append('PlaceholderName', this.PlaceholderName);
    this.formData.append('PlaceholderType', '1');
    this.formData.append('PlaceholderID', this.PlaceholderID);
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('OrganizationID', this.organizationId);
    this.loaderService.show();
    this.close();
    this.documentService.AddContactItemForPlaceholder(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getAllFolders();
          this.documentName = '';
          this.selectedFile = '';
          this.uploadFormValue = true;
          this.uploadForm.reset();
          this.addNewDoc = false;
          this.toastr.success('Import my drive file upload successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.toastr.error('Import my drive file upload failed.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }

      } else {
        this.toastr.error('Import my drive file upload failed.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
      }
    });
  }


  // =========== For Shared with me  =========// 

  getSharedWithMe() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID,
    }
    this.contactsService.getFormFolderSharedWithMeList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.SharedWithMeFormFolderList = this.responseHolder.data;
          this.SharedWithMeFormFolderList.forEach(e => {
            e.isChecked = false
          });
          if (this.SharedWithMeFormFolderList != null) {
            this.SharedWithMeFormFolderList.map((res) => {
              if (res.sharedbyFirstName != null) {
                res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
              }
              if (res.sharedbyLastName != null) {
                res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
              }
              return res;
            });
          }
          this.selectButtonShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = true;
          this.SharedWithMeactive = true;
          this.SharedWithMeMyDriveactive = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = false;
          this.activeNode = "";
          this.menuHeader = [];
          this.parentID = 0;
        }
        else {
          this.selectButtonShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = true;
          this.SharedWithMeactive = true;
          this.SharedWithMeMyDriveactive = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = false;
          this.activeNode = "";
          this.menuHeader = [];
          this.parentID = 0;
          this.SharedWithMeFormFolderList = [];
        }
      }
      else {
      }
    });
  }


  breadCrumbMainSHaredWithMeClick() {
    this.selectButtonShow = false;
    this.getSharedWithMe();
    this.menuHeader = [];
    this.parentID = 0;
  }


  getFormFolderWithFormTemplatesSharedWithMe(form) {
    this.TypeId = form.type;
    var type = form.type;
    //{ 1- Folder, 2- Form}
    if (type == 1) {
      var ReqModel = {
        formFolderID: form.id,
        formFolderName: '',
        permissionType: form.permissionType,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        OfficeID: this.myOfficeID,
        databaseID: Number(this.databaseId),
      };
      this.contactsService.getFormFolderWithFormTemplatesSharedWithMe(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.SharedWithMeFormFolderList = this.responseHolder.data;
            if (this.SharedWithMeFormFolderList != null) {
              this.SharedWithMeFormFolderList.map((res) => {
                if (res.sharedbyFirstName != null) {
                  res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
                }
                if (res.sharedbyLastName != null) {
                  res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
                }
                return res;
              });
            }
            this.parentID = form.id;
            this.menuHeader.push({
              label: form.name,
              id: form.id,
              icon: 'navigate_next',
              permissionType: form.permissionType,
            });

            this.menuHeader = this.menuHeader.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);
          } else {
          }
        } else {
        }
      });
    } else {
    }
  }

  GetAllForms() {
    this.activeNode = "";
    this.dataSource.data = [];
    this.selectButtonShow = false;
    this.isShowForm = true;
    this.isSharedWithMe = false;
    this.isShowMyDrive = false;
    this.isSharedWithMeMyDrive = false;
    this.SharedWithMeactive = false;
    this.menuHeader = [];
    this.menuHeaderMyDrive = [];
    this.getFormFolderListLeftPanel();
    this.getFormFolderListMiddlePanel();
  }

  // =====  Fill ===== //

  projectGroups: any = [];
  groupID: number;
  projectID: number;
  groupType: any;
  groupRelationParticipantMappingID: number;
  relationColour: string = '';
  relationID: number;
  isShare: boolean = false;
  contactemail: any;
  currentRoleContact: any;
  transRoleList: any = [];
  getassign: any;
  type: number = 0;
  ProjectIdForEdit: "";
  searchValues: string = "";
  SendButtonDisabled: boolean = false;
  searchName: string = '';


  closeAssign() {
    this.dialogRef.close();
  }


  addSign(templateRef: TemplateRef<any>, document) {
    this.getassign = document;
    this.SendButtonDisabled = false;
    this.AddCreateProjectforPlaceholder(document, templateRef)
  }

  TabularSign(document) {
    this.TabularSignProject(document)
  }
  signNow(token: any, doc: any) {
    this.params = decodeURIComponent(token);
    const decryptedTokenString = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.params);
    let decryptedToken = JSON.parse(decryptedTokenString)
    let objModel = {
      "OfficeID": decryptedToken.OfficeID,
      "IsReadOnlyFromSentPage": false,
      "ProjectID": decryptedToken.FormID,
      "FormID": decryptedToken.FormID,
      "ContactID": Number(sessionStorage.getItem('transactionID')),
      "ContactPlaceholderID": doc.placeholderID,
      "DocumentHtmls": "",
      "participantJsonList": "",
      "documentFolderID": doc.documentFolderID,
      "Email": "",
      "DatabaseID": decryptedToken.DatabaseID,
      "OrganizationID": decryptedToken.OrganizationID,
      "UserID": decryptedToken.UserID,
      "userEmailFromWhereSignNowCame": sessionStorage.getItem('email')
    };
    let jsonStringToken = JSON.stringify(objModel);
    token = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonStringToken);
    token = encodeURIComponent(token);

    //1pdf 2 tabular 3 html{
    let url = '';
    if (doc.formType == 1)
      url = window.location.href.split(window.location.pathname)[0] + "/request/signature?token=" + token + "&type=1";
    else if (doc.formType == 2)
      url = window.location.href.split(window.location.pathname)[0] + "/request/tabularsignature?token=" + token + "&type=1";
    window.open(url, "_blank");
  }
  TabularSignProject(document) {
    var ReqModel = {
      transactionID: sessionStorage.getItem('transactionID'),
      documentFolderID: document.documentFolderID,
      formID: document.formID,
      formType: FormAuditType.AuditForm,
      placeholderID: document.placeholderID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID
    }
    this.loaderService.show();
    this.documentService.AddCreateProjectforPlaceholder(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if (this.responseHolder.data.token != null && this.responseHolder.data.token != undefined) {
            let formSigningLink = window.location.href.split(window.location.pathname)[0] + "/request/tabularsignature?token=" + response.data.token;
            window.open(formSigningLink, "_blank");
          }
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  AddCreateProjectforPlaceholder(document, templateRef) {
    this.projectGroups = [];
    var ReqModel = {
      transactionID: sessionStorage.getItem('transactionID'),
      documentFolderID: document.documentFolderID,
      formID: document.formID,
      formType: FormAuditType.NormalForm,
      placeholderID: document.placeholderID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID
    }
    this.loaderService.show();
    this.documentService.AddCreateProjectforPlaceholder(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.dialog.open(templateRef, {
          panelClass: 'signatureModal',
        });
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.projectGroups = this.responseHolder.data.participants;//this.responseHolder.data;
          if (this.projectGroups.length > 0) {
            this.participantMessageInfo = this.projectGroups[0].participantMessageInfo;
            this.ProjectIdForEdit = this.projectGroups[0].projectID;
            for (var i = 0, lennew = this.projectGroups.length; i < lennew; ++i) {
              this.projectGroups[i].projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList.filter(m => m.isApprover != true);

            }
          }

          var data = [];
          data = this.projectGroups;
          if (data.length > 0) {
            this.eventLogMessage = "Sent for signature to ";
            var checkGroup = this.projectGroups.filter(m => m.groupType == GroupType.Group);
            if (checkGroup.length > 0) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = checkGroup[0].projGrpRelationParticipantList;
              for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                var email = "";
                if (checkEmailAnonmous != "") {
                  email = checkEmailAnonmous;
                  this.eventLogMessage += '(' + email + '), ';
                }
                if (checkEmail != "") {
                  email = checkEmail;
                  this.eventLogMessage += '(' + email + '), ';
                }
              }
            }

            var checkViewOnly = this.projectGroups.filter(m => m.groupType == GroupType.ViewOnly);
            if (checkViewOnly.length > 0) {
              for (var i = 0, len4 = checkViewOnly.length; i < len4; ++i) {
                var projGrpRelationParticipantList = [];
                projGrpRelationParticipantList = checkViewOnly[i].projGrpRelationParticipantList;
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                  var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                  var email = "";
                  if (checkEmailAnonmous != "") {
                    email = checkEmailAnonmous;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                  if (checkEmail != "") {
                    email = checkEmail;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                }
              }
            }
          }

          this.eventLogMessage = this.eventLogMessage.replace(/,\s*$/, "");

          var check = [];
          check = this.responseHolder.data.participants.filter(x => x.groupType === GroupType.Group);//this.responseHolder.data.filter(x => x.groupType === 1);
          if (check.length > 0) {
            for (var i = 0, len = check.length; i < len; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  if (projGrpRelationParticipantList[i1].contactEmail != "" ||
                    projGrpRelationParticipantList[i1].participantEmail != "" ||
                    projGrpRelationParticipantList[i1].roleID != "0"
                  ) {
                    this.SendButtonDisabled = true;
                    this.loaderService.hide();
                    return;
                  } else {
                    this.SendButtonDisabled = false;
                    // return;
                  }
                }
              }
              else {
              }
            }
          }
        } else {
          this.loaderService.hide();
          this.dialog.closeAll();
          this.projectGroups = [];
        }
      } else {
        this.loaderService.hide();
        this.dialog.closeAll();
        this.projectGroups = [];
      }
    });

  }

  AddRemoveParticipant(document) {
    var ReqModel = {
      transactionID: sessionStorage.getItem('transactionID'),
      documentFolderID: document.documentFolderID,
      formID: document.formID,
      formType: FormAuditType.NormalForm,
      placeholderID: document.placeholderID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID
    }
    this.loaderService.show();
    this.documentService.AddCreateProjectforPlaceholder(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.projectGroups = this.responseHolder.data.participants;//this.responseHolder.data;
          if (this.projectGroups.length > 0) {
            this.ProjectIdForEdit = this.projectGroups[0].projectID;
          }

          var data = [];
          data = this.projectGroups;
          if (data.length > 0) {
            this.eventLogMessage = "Sent for signature to ";
            var checkGroup = this.projectGroups.filter(m => m.groupType == GroupType.Group);
            if (checkGroup.length > 0) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = checkGroup[0].projGrpRelationParticipantList;
              for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                var email = "";
                if (checkEmailAnonmous != "") {
                  email = checkEmailAnonmous;
                  this.eventLogMessage += '(' + email + '), ';
                }
                if (checkEmail != "") {
                  email = checkEmail;
                  this.eventLogMessage += '(' + email + '), ';
                }
              }
            }

            var checkViewOnly = this.projectGroups.filter(m => m.groupType == GroupType.ViewOnly);
            if (checkViewOnly.length > 0) {
              for (var i = 0, len4 = checkViewOnly.length; i < len4; ++i) {
                var projGrpRelationParticipantList = [];
                projGrpRelationParticipantList = checkViewOnly[i].projGrpRelationParticipantList;
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                  var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                  var email = "";
                  if (checkEmailAnonmous != "") {
                    email = checkEmailAnonmous;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                  if (checkEmail != "") {
                    email = checkEmail;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                }
              }
            }
          }

          this.eventLogMessage = this.eventLogMessage.replace(/,\s*$/, "");

          var check = [];
          check = this.responseHolder.data.participants.filter(x => x.groupType === GroupType.Group);//this.responseHolder.data.filter(x => x.groupType === 1);
          if (check.length > 0) {
            for (var i = 0, len = check.length; i < len; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  if (projGrpRelationParticipantList[i1].contactEmail != "" ||
                    projGrpRelationParticipantList[i1].participantEmail != "" ||
                    projGrpRelationParticipantList[i1].roleID != "0"
                  ) {
                    this.SendButtonDisabled = true;
                    this.loaderService.hide();
                    return;
                  } else {
                    this.SendButtonDisabled = false;
                    // return;
                  }
                }
              }
              else {
              }
            }
          }

        } else {
          this.loaderService.hide();
          this.projectGroups = [];
        }
      } else {
        this.loaderService.hide();
        this.projectGroups = [];
      }
    });

  }


  openProject() {
    this.dialog.closeAll();
    sessionStorage.setItem('projectID', this.ProjectIdForEdit);
    sessionStorage.setItem('type', (ProjectTempType.Project).toString()); // 1 for Project and 2 for Template
    sessionStorage.setItem('ImportTemplateShow', 'true');
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateTabularForm', 'false');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateWebForm', 'false');
    this._dataSharingService.sendSelectedProjectName("");
    this.router.navigate(['/esignature/second']);
    sessionStorage.setItem('HeaderModuleName', 'Forms');
    this._dataSharingService.sendSelectedModuleName('Forms');
    this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
  }

  getAllCombinedParticipants(data) {
    return data.reduce((acc, group) => acc.concat(group.projGrpRelationParticipantList), []);
  }

  ProjectSend() {
    if (this.projectGroups.length > 0) {
         var check = [];
         var projGrpRelationParticipantList = [];
         check = this.projectGroups.filter(x => x.groupType === GroupType.Group);
         if (check.length > 0) {       
           projGrpRelationParticipantList =check[0].projGrpRelationParticipantList;
           var checkList = [];
           checkList = projGrpRelationParticipantList.filter(x => (x.contactEmail != null && x.contactEmail != '') || (x.participantEmail != null && x.participantEmail != '') || x.roleID != 0)
            if (checkList.length == 0) {
              this.toastr.warning('Please add atleast 1 participant in a Group.', '', {
                timeOut: 4000,
              });
              return;
             }        
         }
     }
    this.dialog.closeAll();
    var ReqModel = {
      folderId: 1,
      projectId: this.ProjectIdForEdit,
      projectName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      type: 1,  // 1 Form Send , 2 Sand an Save , 3 Save Template Only 
      fileManagerFolderId: 0,
      OfficeID: this.myOfficeID
    }
    this.loaderService.show()
    this.documentService.AddProjectInfoAsTemplete(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.AddProjectEventLog();
          this.toastr.success('Form has sent successfully to participants.', '', {
            timeOut: 3000,
          });
          this.getAllFolders();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  assignUser(templateRef: TemplateRef<any>, isShare: boolean, isRole: boolean, contact: any, p, p1) {
    this.contactemail = "";

    this.showContact = true;
    this.showSearchCore = false;
    this.selectCoreList = [];

    this.isSharedAccessUserPopup = false;
    this.userSelectedList = [];
    this.sharedAccessUserList = [];

    this.stateCtrl.setValue('');

    this.type = p1.type;
    this.projectID = p1.projectID;
    this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
    this.groupID = p.groupID;
    this.relationColour = p.relationColour;
    this.relationID = p.relationID;
    this.showAddButton = false;
    this.isShare = isShare;
    this.contactemail = p.contactEmail;
    this.isRolePopup = isRole;
    this.isSharedAccessRolePopup = false;
    if (isRole)
      this.currentRoleContact = contact;
    this.transRoleList = [];
    this.contactsList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectedsharedAccessRole = [];
    this.showContactRoleAddButton = false;
    this.dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });

  }

  assignUserNew(isShare: boolean, isRole: boolean, contact: any, p, p1) {
    this.contactemail = "";

    this.showContact = true;
    this.showSearchCore = false;
    this.selectCoreList = [];

    this.isSharedAccessUserPopup = false;
    this.userSelectedList = [];
    this.sharedAccessUserList = [];

    this.stateCtrl.setValue('');

    this.typeOfParticipant=p.typeOfParticipant;
    this.type = p1.type;
    this.projectID = p1.projectID;
    this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
    this.groupID = p.groupID;
    this.relationColour = p.relationColour;
    this.relationID = p.relationID;
    this.showAddButton = false;
    this.isShare = isShare;
    this.contactemail = p.contactEmail;
    this.isRolePopup = isRole;
    this.isSharedAccessRolePopup = false;
    if (isRole)
    this.currentRoleContact = contact;
    this.transRoleList = [];
    this.contactsList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectedsharedAccessRole = [];
    this.showContactRoleAddButton = false;
    
     const dialogRef = this.dialog.open(Add3ctypeformComponent, {     
        data: {
               moduleName:"",
               typeOfParticipant:this.typeOfParticipant    
              },
            panelClass: 'signatureModal',
          });
        dialogRef.afterClosed().subscribe(result => {
          if(result!=null && result!=undefined){
            this.addUpdateParticipantsNew(result);
          }      
      });
  }

  addUpdateParticipantsNew(result){
    //this.closeAssign();
    this.peoples =[];
    this.peoples = result;

    //=== For Email ======//
    if (result[0].typeOfParticipant==0) {
        if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var req = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID:0,
            contactID: 0,
            companyID:0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID:0,
            relationID: this.relationID,
            relationColour: this.relationColour,           
            projectID: this.projectID,
            emailFieldID:0,
            nameFieldID:0,
            roleID: 0,            
            typeOfParticipant:this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(req)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.documentService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
    }

    //=== For User ======//
    if (result[0].typeOfParticipant==4) {
        if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqUser = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID:0,
            contactID: 0,
            companyID:0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID:0,
            relationID: this.relationID,
            relationColour: this.relationColour,           
            projectID: this.projectID,
            emailFieldID:0,
            nameFieldID:0,
            roleID: 0,            
            typeOfParticipant:this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqUser)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.documentService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
    }

     //=== For Role ======//
     if (result[0].typeOfParticipant==5) {
      if (this.peoples.length > 0) {
      var relationListModels = [];
      for (var i = 0, len = this.peoples.length; i < len; ++i) {
        var reqRole = {
          groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
          groupID: this.groupID,
          coreID:0,
          contactID: 0,
          companyID:0,
          contactEmail: null,
          selectedContactFieldEmailID:0,
          relationID: this.relationID,
          relationColour: this.relationColour,           
          projectID: this.projectID,
          emailFieldID:0,
          nameFieldID:0,
          roleID: this.peoples[i].roleID,            
          typeOfParticipant:this.peoples[i].typeOfParticipant,
        }
        relationListModels.push(reqRole)
      }

      var ReqModel = {
        relationListModels: relationListModels,
        userID: this.currentUser.UID,
        databaseID: Number(this.databaseId),
        organizationID: Number(this.organizationId),
        type: this.type,
        OfficeID:this.myOfficeID
      }
      this.loaderService.show();
      this.documentService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.AddRemoveParticipant(this.getassign);
            this.toastr.success('Participant Added successfully.', '', {
              timeOut: 3000,
            });
            this.peoples = [];
            this.showAddButton = false;
            this.loaderService.hide();             
          }
        }
      });      
    }     
     }

      //=== For Core ======//
     if (result[0].typeOfParticipant==1) {
        if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqCore = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: this.peoples[i].coreID,
            contactID: 0,
            companyID:0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID:0,
            relationID: this.relationID,
            relationColour: this.relationColour,           
            projectID: this.projectID,
            emailFieldID:0,
            nameFieldID:0,
            roleID: 0,            
            typeOfParticipant:this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqCore)
        }
  
        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.documentService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
     }

      //=== For Contact ======//
     if (result[0].typeOfParticipant==2) {
        if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqContact = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: this.peoples[i].contactID,
            companyID:0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID:0,
            relationID: this.relationID,
            relationColour: this.relationColour,           
            projectID: this.projectID,
            emailFieldID:0,
            nameFieldID:0,
            roleID: 0,            
            typeOfParticipant:this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqContact)
        }
  
        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.documentService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
     }

      //=== For Company ======//
      if (result[0].typeOfParticipant==3) {
        if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqCompany= {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID:this.peoples[i].companyID,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID:0,
            relationID: this.relationID,
            relationColour: this.relationColour,           
            projectID: this.projectID,
            emailFieldID:0,
            nameFieldID:0,
            roleID: 0,            
            typeOfParticipant:this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqCompany)
        }
  
        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.documentService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {                       
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
     }
   }

  addUpdateParticipants() {
    this.closeAssign();
    if (this.showContact == true) {
      if (this.contactemail != "") {
        var shortname = this.contactemail.substring(0, 1)
        var req1 = {
          name: "",
          email: this.contactemail,
          img: "",
          contactID: 0,
          roleID: 0,
          isShared: this.isShare,
          shortName: shortname,
        }
        this.peoples.unshift(req1);
      }
      if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var req = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            relationColour: this.relationColour,
            contactID: this.peoples[i].contactID,
            relationID: this.relationID,
            projectID: this.projectID,//sessionStorage.getItem('projectID'),
            roleID: null,
            contactEmail: this.contactemail
          }
          relationListModels.push(req)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type, //Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.documentService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });

      }
    }

    if (this.showRole == true) {
      if (this.selectedsharedAccessRole.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.selectedsharedAccessRole.length; i < len; ++i) {
          var req = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            relationColour: this.relationColour,
            contactID: null,
            relationID: this.relationID,
            projectID: this.projectID,//sessionStorage.getItem('projectID'),
            roleID: this.selectedsharedAccessRole[i].roleID,
            contactEmail: null
          }
          relationListModels.push(req)
        }
        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type, //Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.documentService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.selectedsharedAccessRole = [];
              this.showAddButton = false;
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    }

    if (this.showSearchCore == true) {
      if (this.selectCoreList.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.selectCoreList.length; i < len; ++i) {
          var reqCore = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            relationColour: this.relationColour,
            coreID: this.selectCoreList[i].coreID,
            relationID: this.relationID,
            projectID: this.projectID,//sessionStorage.getItem('projectID'),
            roleID: null,
            contactEmail: this.contactemail
          }
          relationListModels.push(reqCore)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type, //Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.documentService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });

      }
    }
    if (this.isSharedAccessUserPopup == true) {

      if (this.userSelectedList.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.userSelectedList.length; i < len; ++i) {
          var req11 = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            relationColour: this.relationColour,
            contactID: 0,
            relationID: this.relationID,
            projectID: this.projectID,
            roleID: null,
            contactEmail: this.userSelectedList[i].email,
          }
          relationListModels.push(req11)
        }

        var ReqModels = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type, //Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.documentService.AddEditProjectGroupRelationParticipant(ReqModels).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    }

  }


  // addUpdateParticipants() {
  //   this.closeAssign();
  //   if (this.isSharedAccessRolePopup == false) {
  //     if (this.peoples.length > 0) {
  //       var relationListModels = [];
  //       for (var i = 0, len = this.peoples.length; i < len; ++i) {
  //         var req = {
  //           groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
  //           groupID: this.groupID,
  //           relationColour: this.relationColour,
  //           contactID: this.peoples[i].contactID,
  //           relationID: this.relationID,
  //           projectID: this.projectID,//sessionStorage.getItem('projectID'),
  //           roleID: null,
  //           contactEmail: this.contactemail
  //         }
  //         relationListModels.push(req)
  //       }

  //       var ReqModel = {
  //         relationListModels: relationListModels,
  //         userID: this.currentUser.UID,
  //         databaseID: Number(this.databaseId),
  //         organizationID: Number(this.organizationId),
  //         type: this.type, //Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
  //         OfficeID: this.myOfficeID
  //       }
  //       this.loaderService.show();
  //       this.documentService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
  //         if (response != undefined) {
  //           this.responseHolder = response;
  //           this.loaderService.hide();
  //           if (this.responseHolder.status == this.statusConst.statusSuccess) {
  //             this.AddRemoveParticipant(this.getassign);
  //             this.toastr.success('Participant Added successfully.', '', {
  //               timeOut: 3000,
  //             });
  //             this.peoples = [];
  //             this.showAddButton = false;
  //           } else {
  //             this.loaderService.hide();
  //           }
  //         } else {
  //           this.loaderService.hide();
  //         }
  //       });

  //     }
  //     else {
  //       this.peoples.push({
  //         groupID: this.groupID,
  //         relationColour: this.relationColour,
  //         contactID: 0,
  //         relationID: this.relationID,
  //         projectID: sessionStorage.getItem('projectID'),
  //         roleID: null,
  //         contactEmail: this.searchName,
  //       });
  //       if (this.peoples.length > 0) {
  //         var relationListModels = [];
  //         for (var i = 0, len = this.peoples.length; i < len; ++i) {
  //           var req = {
  //             groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
  //             groupID: this.groupID,
  //             relationColour: this.relationColour,
  //             contactID: this.peoples[i].contactID,
  //             relationID: this.relationID,
  //             projectID: this.projectID,//sessionStorage.getItem('projectID'),
  //             roleID: null,
  //             contactEmail: this.peoples[i].contactEmail//this.contactemail
  //           }
  //           relationListModels.push(req)
  //         }

  //         var ReqModel = {
  //           relationListModels: relationListModels,
  //           userID: this.currentUser.UID,
  //           databaseID: Number(this.databaseId),
  //           organizationID: Number(this.organizationId),
  //           type: this.type, //Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
  //           OfficeID: this.myOfficeID
  //         }
  //         this.loaderService.show();
  //         this.documentService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
  //           if (response != undefined) {
  //             this.responseHolder = response;
  //             this.loaderService.hide();
  //             if (this.responseHolder.status == this.statusConst.statusSuccess) {
  //               this.AddRemoveParticipant(this.getassign);
  //               this.toastr.success('Participant Added successfully.', '', {
  //                 timeOut: 3000,
  //               });
  //               this.peoples = [];
  //               this.showAddButton = false;
  //             } else {
  //               this.loaderService.hide();
  //             }
  //           } else {
  //             this.loaderService.hide();
  //           }
  //         });
  //       }
  //       // this.dialog.closeAll();
  //     }
  //   } else {
  //     if (this.selectedsharedAccessRole.length > 0) {
  //       var relationListModels = [];
  //       for (var i = 0, len = this.selectedsharedAccessRole.length; i < len; ++i) {
  //         var req = {
  //           groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
  //           groupID: this.groupID,
  //           relationColour: this.relationColour,
  //           contactID: null,
  //           relationID: this.relationID,
  //           projectID: this.projectID,//sessionStorage.getItem('projectID'),
  //           roleID: this.selectedsharedAccessRole[i].roleID,
  //           contactEmail: null
  //         }
  //         relationListModels.push(req)
  //       }
  //       var ReqModel = {
  //         relationListModels: relationListModels,
  //         userID: this.currentUser.UID,
  //         databaseID: Number(this.databaseId),
  //         organizationID: Number(this.organizationId),
  //         type: this.type, //Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
  //         OfficeID: this.myOfficeID
  //       }
  //       this.loaderService.show();
  //       this.documentService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
  //         if (response != undefined) {
  //           this.responseHolder = response;
  //           this.loaderService.hide();
  //           if (this.responseHolder.status == this.statusConst.statusSuccess) {
  //             this.AddRemoveParticipant(this.getassign);
  //             this.toastr.success('Participant Added successfully.', '', {
  //               timeOut: 3000,
  //             });
  //             this.selectedsharedAccessRole = [];
  //             this.showAddButton = false;
  //           } else {
  //             this.loaderService.hide();
  //           }
  //         } else {
  //           this.loaderService.hide();
  //         }
  //       });
  //     }
  //   }
  // }

  removeItemRoleParticipant(item: any, isSharedAccessRolePopup: boolean) {
    if (this.isSharedAccessRolePopup) {
      const index = this.selectedsharedAccessRole.indexOf(item);
      if (index >= 0) {
        this.selectedsharedAccessRole.splice(index, 1);
      }
      if (this.selectedsharedAccessRole.length > 0) {
        this.showAddButton = true;
      }
      if (this.selectedsharedAccessRole.length == 0) {
        this.showAddButton = false;
      }
    }
  }

  onEnter(event) {
    if (event.target.value == event.target.value.match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')) {
      // if(event.target.value == event.target.value.match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
      //  &&  (this.contactsList.length ==1) && (this.contactsList[0].contactID == 0)){
      this.contactemail = event.target.value;
      this.peoples.push({
        groupID: this.groupID,
        relationColour: this.relationColour,
        contactID: 0,
        relationID: this.relationID,
        projectID: this.ProjectIdForEdit,
        roleID: null,
        contactEmail: this.contactemail,
      });
      this.addUpdateParticipants();
    }

  }

  getContactListCoreImplementation(searchValue: any) {
    this.searchValues = searchValue;
    this.searchName = searchValue;
    if (searchValue == "") {
      this.contactemail = "";
      this.peoples = [];
      this.contactsList = [];
      return;
    }

    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      UserID: this.currentUser.UID,
      searchValue: searchValue,
      PageSize: 0,
      groupID: this.groupID
    }
    this.documentService.GetContactListCoreImplementation(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.contactsList = response.data.contactListModel;
          this.contactsList.forEach(e => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
          });
        }
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var check = re.test(String(searchValue).toLowerCase());
        if (check == true) {
          this.contactemail = searchValue;
          this.showAddButton = true;
        }
        if (check == false) {
          this.contactemail = "";
          this.showAddButton = false;
        }
      }

      if (searchValue == "") {
        this.contactemail = "";
        this.peoples = [];
        this.contactsList = [];
      }
    })
  }


  contactSelected(contactSelected: any) {
    if (contactSelected.contactID == 0) {
      this.dialog.closeAll();
      this.addNew(this.SelectedModuleName[0].orgModuleName);
      // this.addNew('Contact');
      return;
    }
    if (this.peoples.length > 0) {
      return;
    }

    this.peoples.push({
      name: contactSelected.name,
      email: contactSelected.email,
      img: contactSelected.imageUrl,
      contactID: contactSelected.contactID,
      roleID: 0,
      isShared: this.isShare,
      shortName: contactSelected.shortName,
    });
    if (this.peoples.length > 0) {
      this.showAddButton = true;
    }
    else {
      this.showAddButton = false;
    }
  }

  addNew(module) {
    this.Module = module;
    this.showAddContact = !this.showAddContact;
  }
  getToogleInformation() {
    this.toogleInformation = !this.toogleInformation;
  }
  // Remove Relation 
  RemoveRelation(group, p) {
    const message = `Are you sure you want to delete this participant?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          if (group !== undefined) {

            var relationListModels = [];
            var req = {
              groupRelationParticipantMappingID: group.groupRelationParticipantMappingID,
              groupID: group.groupID,
              relationColour: group.relationColour,
              contactID: null,
              relationID: group.relationID,
              projectID: p.projectID,//sessionStorage.getItem('projectID'),
              roleID: null,
            }
            relationListModels.push(req)

            var ReqModel = {
              relationListModels: relationListModels,
              userID: this.currentUser.UID,
              databaseID: Number(this.databaseId),
              organizationID: Number(this.organizationId),
              type: p.type,//Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
              OfficeID: this.myOfficeID
            }
            this.documentService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe((response) => {
              if (response != undefined) {
                this.responseHolder = response;
                this.loaderService.hide();
                if (this.responseHolder.status == this.statusConst.statusSuccess) {
                  this.AddRemoveParticipant(this.getassign);
                  this.toastr.success('Participant removed successfully', '', {
                    timeOut: 3000,
                  });
                } else {
                  this.loaderService.hide();
                }
              } else {
                this.loaderService.hide();
              }
            });
          }
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  getShortName(fullName) {
    return fullName.split(' ').map(n => n[0]).join('');
  }

  // Request Document // 

  RequestFiles(message: boolean) {
    var SharedSelectedFile = [];
    var SharedSelectedFileNew = [];
    SharedSelectedFile = this.selectedFileArray.filter((s) => s.placeholderType != 2);
    for (let i = 0; i < this.selectedFileArray.length; i++) {
      var placeholderType = this.selectedFileArray[i].selectedDocument.placeholderType;
      if (placeholderType != 2) {
        var ReqModel = {
          "transactionID": sessionStorage.getItem('transactionID'),
          "documentFolderID": this.selectedFileArray[i].selectedDocument.documentFolderID,
          "documentStatus": this.selectedFileArray[i].selectedDocument.documentStatus,
          "documentType": this.selectedFileArray[i].selectedDocument.documentType,
          "formID": this.selectedFileArray[i].selectedDocument.formID,
          "isRequired": this.selectedFileArray[i].selectedDocument.isRequired,
          "isChecked": this.selectedFileArray[i].selectedDocument.isChecked,
          "placeholderID": this.selectedFileArray[i].selectedDocument.placeholderID,
          "placeholderName": this.selectedFileArray[i].selectedDocument.placeholderName,
          "placeholderType": this.selectedFileArray[i].selectedDocument.placeholderType,
        }
        SharedSelectedFileNew.push(ReqModel);
      }
    }

    if (SharedSelectedFileNew.length > 0) {
      this.showShareFile.emit(message);
      this._dataSharingService.sendSelectedRequestDocumentForContact(SharedSelectedFileNew);
    }

  }



  // Fill PlaceHolder == //

  FillPlaceholder(document) {

  }


  // To Add Project EventLog //
  async AddProjectEventLog() {
    try {
      var ReqModel = {
        projectID: this.ProjectIdForEdit,
        ipAddress: this.ipAddress,
        message: this.eventLogMessage,
        eventType: 1, //Send=1, View=2, Sign=3, Complete=4, Decline=5, Assign=6
        device: this.device,
        browser: this.browsername,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
      }
      //return;
      const result = await this.documentService.AddProjectEventLog(ReqModel).toPromise();
      this.responseHolder = result;
      if (this.responseHolder.status === this.statusConst.statusSuccess) {

      } else {
        this.loaderService.hide();
      }
    } catch (e) {
      Observable.throw(e);
    }
  }



  // For Multiple file upload in Drag Drop Zone // 

  UploadedFilesDragZone: any = [] = [];

  selectFilesFromDragZone(event, selectedFolder) {
    this.loaderService.show();
    this.formData = new FormData();
    this.UploadedFilesDragZone = [];
    this.UploadedFilesDragZone = event.target.files;
    for (let i = 0; i < this.UploadedFilesDragZone.length; i++) {
      if (this.UploadedFilesDragZone[i].name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
        return;
      }
      var documenttype = "";
      var documentName = "";
      var FullPath = this.UploadedFilesDragZone[i].name;
      var newfilename = FullPath.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');

      var documentNameSplit = newfilename.split('.');
      //var documentNameSplit = FullPath.split('.');
      documentName = documentNameSplit[0];
      documenttype = documentNameSplit[1];

      // if (documentNameSplit.length > 2) {
      //   this.toastr.warning('Please upload valid file name, please rename file.', '', {
      //     timeOut: 3000,
      //   });
      //   this.loaderService.hide();
      //   return;
      // }

      this.formData.append('files', this.UploadedFilesDragZone[i]);
      this.formData.append('DocumentDetails', documenttype + '|' + '0' + '|' + '1' + '|' + documentName);
    }
    this.formData.append('TransactionID', sessionStorage.getItem('transactionID'));
    this.formData.append('DocumentFolderID', selectedFolder.documentFolderID);
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('OfficeID', this.myOfficeID);
    this.formData.append('OfficeIDList', this.OfficeIDList);
    this.formData.append('DatabaseID', this.databaseId);
    // return;
    this.documentService.AddContactMultiDocument(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        this.UploadedFilesDragZone = [];
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getAllFolders();
          this.uploadFormValue = true;
          this.addNewDoc = false;
          this.toastr.success('File uploaded successfully.', '', {
            timeOut: 3000,
          });
        }
        else {
          this.toastr.error('File Upload failed.', '', {
            timeOut: 3000,
          });
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      } else {
        this.UploadedFilesDragZone = [];
        this.loaderService.hide();
      }
    });
  }




  HTMLFormSign(document) {
    if (document.formType == 3) {
      //  Core=1, Contact=2, Company=3
      var contactId = sessionStorage.getItem('transactionID');
      let HtmlFormSignLink = window.location.href.split(window.location.pathname)[0] + "/request/HtmlFormSign?token=" + document.token + "&emailId=" + this.LoggedInEmailId + "&type=" + '2' + "&placeholderID=" + document.placeholderID + "&transactionID=" + this.transactionID + ""
      window.open(HtmlFormSignLink, "_blank");
    }
  }


  openHtmlData(message: boolean, document) {
    var ReqModel = {
      // formID :document.formID,
      // transactionID: this.transactionID,
      // placeholderID: document.placeholderID,
      // formID :0
      transactionID: this.transactionID,
      placeholderID: document.placeholderID,
      FormReportShow: false,
      reportData: []
    }
    this._dataSharingService.sendSelectedHTMLDataForContact(ReqModel);
    this.htmlData.emit(message);
  }




  // ==========  For Drag Drop Folder ========= //

  getConnectedList(): any[] {
    return this.folderList.map((x) => `${x.documentFolderID}`);
  }

  // For Reorderfolders // 

  dropGroup(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.folderList, event.previousIndex, event.currentIndex);
    var itemList = [];
    if (this.folderList.length > 0) {
      for (var i = 0, len = this.folderList.length; i < len; ++i) {
        var obj = {
          itemId: this.folderList[i].documentFolderID,
          position: i + 1
        }
        itemList.push(obj);
      }
    }
    // return;
    var ReqModel = {
      transactionId: Number(this.transactionID),
      reorderItems: itemList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    };
    this.loaderService.show();
    this.documentService.Reorderfolders(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getAllFolders();
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }



  dropItem(event: CdkDragDrop<any>) {
    if (event.previousContainer.id === event.container.id) {
      // For ReorderPlaceholders  for Same Folder //   
      // if(event.previousIndex==0)
      //   moveItemInArray(event.container.data, event.previousIndex, event.currentIndex-1);
      //  else
      //   moveItemInArray(event.container.data, event.previousIndex-1, event.currentIndex-1);

      this.folderList.find(m => m.documentFolderID == Number(event.container.id)).placeholders[event.previousContainer.data.index] = event.container.data.item
      this.folderList.find(m => m.documentFolderID == Number(event.container.id)).placeholders[event.container.data.index] = event.previousContainer.data.item

      let documentFolderID = 0;
      let NewfolderList = [];
      documentFolderID = Number(event.container.id);
      NewfolderList = this.folderList.find(m => m.documentFolderID == Number(event.container.id)).placeholders;
      let itemList = [];
      if (NewfolderList.length > 0) {
        for (let i = 0, len = NewfolderList.length; i < len; ++i) {
          let obj = {
            itemId: NewfolderList[i].placeholderID,
            position: i
          }
          this.folderList.find(m => m.documentFolderID == Number(event.container.id)).placeholders[i].position = i;
          itemList.push(obj);
        }
      }
      // return;
      let ReqModel = {
        folderId: documentFolderID,
        movetoFolderId: documentFolderID,
        // transactionId: Number(this.transactionID),
        reorderItems: itemList,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        officeIDList: this.OfficeIDList,
        databaseID: Number(this.databaseId)
      };
      this.loaderService.show();
      this.documentService.ReorderPlaceholders(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            // this.getAllFolders();
            this.loaderService.hide();
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    } else {
      transferArrayItem(event.previousContainer.data.data,
        event.container.data.data,
        event.previousContainer.data.index,
        event.container.data.index);

      //this.folderList.find(m=>m.documentFolderID==Number(event.container.id)).placeholders[event.previousContainer.data.index]=event.container.data.item;
      //this.folderList.find(m=>m.documentFolderID==Number(event.container.id)).placeholders[event.container.data.index]=event.previousContainer.data.item;

      let documentFolderID = 0;
      let NewfolderList = [];
      NewfolderList = event.container.data.data;
      documentFolderID = Number(event.container.id);
      NewfolderList.forEach(ele => {
        if (ele.documentFolderID !== documentFolderID) {
          ele.documentFolderID = documentFolderID;
        }
      });

      let itemList = [];
      if (NewfolderList.length > 0) {
        for (let i = 0, len = NewfolderList.length; i < len; ++i) {
          let obj = {
            itemId: NewfolderList[i].placeholderID,
            position: i
          }
          this.folderList.find(m => m.documentFolderID == Number(event.container.id)).placeholders[i].position = i;
          itemList.push(obj);
        }
      }
      for (let k = 0; k < this.folderList.find(m => m.documentFolderID == Number(event.previousContainer.id)).placeholders.length; k++) {
        this.folderList.find(m => m.documentFolderID == Number(event.previousContainer.id)).placeholders[k].position = k;
      }
      // return;
      let ReqModel = {
        folderId: Number(event.previousContainer.id),
        movetoFolderId: documentFolderID,
        // transactionId: Number(this.transactionID),
        reorderItems: itemList,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        officeIDList: this.OfficeIDList,
        databaseID: Number(this.databaseId)
      };
      this.loaderService.show();
      this.documentService.ReorderPlaceholders(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            // this.getAllFolders();
            this.loaderService.hide();
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }


  // ===  For ReorderfoldersforNewAddedfolder ====//

  // ReorderfoldersforNewAddedfolder() {
  //   var ReqModel = {
  //     transactionId: Number(this.transactionID),
  //     reorderItems: null,
  //     userID: this.currentUser.UID,
  //     organizationID: Number(this.organizationId),
  //     officeID: this.myOfficeID,     
  //     officeIDList: this.OfficeIDList,
  //     databaseID: Number(this.databaseId)
  //    };    
  //    this.documentService.ReorderfoldersforNewAddedfolders(ReqModel).subscribe((response) => {
  //    if (response != undefined) {
  //         this.responseHolder = response;
  //         if (this.responseHolder.status == this.statusConst.statusSuccess) {           
  //           this.getAllFolders();
  //         } else {           
  //         }
  //       } else {         
  //       }
  //     });    
  // }


  mergeButton: boolean = false;

  //merge selected File
  mergeSelectedFile() {
    this.selectedFileArray.forEach(s => {
      this.selectedFileArray.push(s.documentPath);
    });
    this.documentService.mergePdfFiles(this.selectedFileArray).subscribe((response) => {
      if (response !== undefined) {
        const data = 'data:' + response.data.contentType + ';base64,' + response.data.base64URL;
        FileSaver.saveAs(data);
      } else {
        this.toastr.error('File download failed.', '', {
          timeOut: 3000,
        });
      }
    });
    this.selectedFileArray = [];
    this.getAllFolders();
    this.ShowDownloadButton = false;
    this.ShowDeleteButton = false;
    this.ShowRequestButton = false;
    this.itemSelectedSortBy = true;
  }

  shareOnPortal() {
    var message = `Are you sure you want to Share on Portal?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        var filesForPortal = [];
        var filesForPortalData = [];
        filesForPortal = this.selectedFileArray.filter((s) => s.placeholderType != 2);
        if (filesForPortal.length > 0) {
          for (let i = 0; i < filesForPortal.length; i++) {
            var model = {
              //url: this.selectedFileArray[i].selectedDocument.azureblobPath
              documentID: filesForPortal[i].selectedDocument.coreDocumentID,
              placeholderID: filesForPortal[i].selectedDocument.placeholderID
            }
            filesForPortalData.push(model);
          }
        }
        if (filesForPortal.length == 0) {
          this.toastr.warning('Please select proper document.', '', {
            timeOut: 3000,
          });
          return;
        }
        if (filesForPortalData.length == 0) {
          this.toastr.warning('Please select proper document.', '', {
            timeOut: 3000,
          });
          return;
        }
        var ReqModel = {
          cid: Number(this.transactionID),
          documents: filesForPortalData,
          isShared: true,
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
          officeID: this.myOfficeID
        }
        this.loaderService.show();
        this.documentService.shareDocsOnPortal(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.selectedFileArray = [];
              this.toastr.success('document shared on portal successfully.', '', {
                timeOut: 3000,
              });
              this.getAllFolders();
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    });
  }



  contactNames: string = "Email";
  coreNames: string = "";
  menuModulesList: any = [] = [];
  objectList: any = [];
  attachedToCoreList: any = [] = [];
  CorefolderID: number = 0;
  roleIdList: any = [];
  selectCoreList: any = [];
  showSearchCore: boolean = false;
  showContact: boolean = true
  showRole: boolean = false;
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  stateCtrlValue: string;
  states = this.objectList;

  searchCore(val) {
    if (val.length >= 2) {
      this.attachedToCoreList = [];
      if (val != '') {
        this.searchName = val;
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCore(val)
        }, 500);
      } else {
        this.attachedToCoreList = [];
      }
    }
  }


  getsearchCore(searchValue: any) {
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCCC.length > 0) {
      this.CorefolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CorefolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.documentService.searchCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToCoreList = response.data;
          this.attachedToCoreList.push(
            {
              "coreID": 0,
              "name": "Create New",
              "email": "",
              "imageUrl": "",
              "isShared": false,
              "coreContactUserMapID": 0,
              "trasactionalRoleIds": [],
              "shortName": ""
            }
          )
        } else {
          this.attachedToCoreList = [];
        }
      }
    })
  }

  coreSelected(coreSelected: any) {
    if (coreSelected.coreID == 0) {
      this.dialog.closeAll();
      this.addNew('Core');
      return;
    }
    if (this.selectCoreList.length > 0) {
      return;
    }
    if (coreSelected.email == "" || coreSelected.email == null || coreSelected.email == undefined) {
      this.toastr.warning('Selected ' + this.contactNames + ' is not added email id.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.stateCtrl.setValue('');
    this.selectCoreList.push({
      name: coreSelected.name,
      email: coreSelected.email,
      img: coreSelected.imageUrl,
      coreID: coreSelected.coreID,
      roleID: 0,
      isShared: this.isShare,
      shortName: coreSelected.shortName,
    });
    if (this.selectCoreList.length > 0) {
      this.showAddButton = true;
    }
    else {
      this.showAddButton = false;
    }
  }

  removeCore(item: any) {
    const index = this.selectCoreList.indexOf(item);
    if (index >= 0) {
      this.selectCoreList.splice(index, 1);
    }
    if (this.selectCoreList.length == 0) {
      this.showAddButton = false;
    }
    this.showSearchCore = true;
  }


  @Output() openAIDetail = new EventEmitter<any>();
  openAIToolDetail: boolean = false;
  azureblobPath: string = "";
  documentsId: number = 0;
  typeIdForTask: number = 0;
  documentNames: string = "";

  showBindingFieldDetail(document: any) {
    this.azureblobPath = document.azureblobPath;
    this.documentsId = document.fileManagerItemID;
    this.documentNames = document.name;
    this.openAIDetail.emit(document);
  }


  sharedAccessUserList: any = [] = [];
  userSelectedList: any = [] = [];
  selectedUser: boolean = false;
  isSharedAccessUserPopup: boolean = false;

  // searchUsers(val) {
  //   if (val.length >= 2) {
  //     this.sharedAccessUserList = [];
  //     if (val != '') {
  //       clearTimeout(this.timeout)
  //       this.timeout = setTimeout(() => {
  //         this.getUserListCoreImplementations(val)
  //       }, 500);
  //     } else {
  //       this.sharedAccessUserList = [];
  //     }
  //   }
  // }

  getUserListCoreImplementations(searchValue: any) {
    if (searchValue == "" || searchValue == null || searchValue == undefined) {
      this.sharedAccessUserList = [];
      return;
    }
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      searchKey: searchValue.trim(),
      PageSize: 0,
      pageIndex: 0,
      UserID: this.currentUser.UID
    }
    this.documentService.GetUserList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.sharedAccessUserList = response.data.userModel;
          this.sharedAccessUserList.map((res) => {
            if (res.email != null) {
              res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
            }
            if (res.firstName != null) {
              res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            }
            if (res.lastName != null) {
              res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            }
            return res;
          });
          this.sharedAccessUserList = this.sharedAccessUserList;
        }
      }
    });
  }


  usersSelected(userSelected: any) {
    var user = [];
    user = this.userSelectedList.filter(m => m.userID == userSelected.userID);
    if (user.length == 0) {
      var shortName = userSelected.firstName.match(/\b(\w)/g).join('');
      this.userSelectedList.push({
        name: userSelected.firstName + " " + userSelected.lastName,
        email: userSelected.email,
        userID: userSelected.userID,
        img: "",
        shortName: shortName,
      });
    } else {
      this.toastr.warning('User allready added.', '', {
        timeOut: 3000,
      });
    }
    if (this.userSelectedList.length > 0) {
      this.showAddButton = true;
    }
    else {
      this.showAddButton = false;
    }
  }

  removeUser(item: any) {
    const index = this.userSelectedList.indexOf(item);
    if (index >= 0) {
      this.userSelectedList.splice(index, 1);
    }
    if (this.userSelectedList.length == 0) {
      this.showAddButton = false;
    }
  }



  //  shareOnPortal() {
  //   var filesForPortal=[];
  //   var filesForPortalData=[];
  //   filesForPortal = this.selectedFileArray.filter((s) => s.placeholderType != 2);
  //   if(filesForPortal.length>0){
  //     for (let i = 0; i < filesForPortal.length; i++) {     
  //        var model={
  //          //url: this.selectedFileArray[i].selectedDocument.azureblobPath
  //          documentID:filesForPortal[i].selectedDocument.coreDocumentID,
  //          placeholderID:filesForPortal[i].selectedDocument.placeholderID
  //        }
  //        filesForPortalData.push(model);
  //      }
  //    } 
  //   if(filesForPortal.length==0){
  //     this.toastr.warning('Please select proper document.', '', {
  //       timeOut: 3000,
  //     });
  //     return;
  //   }
  //   if(filesForPortalData.length==0){
  //     this.toastr.warning('Please select proper document.', '', {
  //       timeOut: 3000,
  //     });
  //     return;
  //   }
  //   var ReqModel = {
  //     cid:Number(this.transactionID),
  //     documents:filesForPortalData,
  //     isShared:true,
  //     userID: this.currentUser.UID,
  //     organizationID: Number(this.organizationId),
  //     databaseID: Number(this.databaseId),
  //     officeID: this.myOfficeID
  //   }
  //   //return;
  //   this.loaderService.show();
  //   this.documentService.shareDocsOnPortal(ReqModel).subscribe((response) => {
  //     if (response != undefined) {
  //       this.responseHolder = response;
  //       this.loaderService.hide();
  //       if(this.responseHolder.status == this.statusConst.statusSuccess) {
  //         this.selectedFileArray=[];
  //         this.toastr.success('document shared successfully.', '', {
  //           timeOut: 3000,
  //         });
  //         this.getAllFolders();
  //       } else {
  //         this.loaderService.hide();
  //       }
  //     } else {
  //       this.loaderService.hide();
  //     }
  //   });
  // }

}



interface FoodNode {
  formFolderName: string;
  children?: FoodNode[];
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}


/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  formFolderName: string;
  level: number;
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}


interface FoodNodeFileManager {
  name: string;
  children?: FoodNodeFileManager[];
  fileManagerItemID: number;
  parentID: number;
  isShared: boolean;
}


interface ExampleFlatNodeFileManager {
  expandable: boolean;
  name: string;
  level: number;
  fileManagerItemID: number;
  parentID: number;
  isShared: boolean;
}
